import React, { useContext, useEffect, useState, useCallback, useMemo, useRef } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';
import { Breakpoint, Body1, TextAlignment as TextAlignment$1, H5, ScreenSize as ScreenSize$1, Body1Styles as Body1Styles$1, Subtitle3, GlobalStyles } from '@arcteryx/components-typography';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router-dom';
import { connectStats, createConnector, connectRefinementList, connectSortBy, connectSearchBox, InstantSearch, Configure, connectHitInsights, connectHits } from 'react-instantsearch-dom';
import { Trans, useTranslation } from 'react-i18next';
import { SiteContext, SiteContextProvider } from '@arcteryx/components-contexts';
import PropTypes from 'prop-types';
import { FilterApplied, FilterTitle, FilterDropdown, Sort, FilterBarBase, FilterBarWrapper, ItemCount } from '@arcteryx/components-filterbar';
import { adaptRefinementsApplied, adaptSort, adaptProductTile, ProductTile, Product } from '@arcteryx/data-models';
import { refineValue } from 'react-instantsearch-core/dist/es/core/indexUtils';
import { getLanguageFromLangCode } from '@arcteryx/js-language';
import qs from 'qs';
import { autocomplete, getAlgoliaResults } from '@algolia/autocomplete-js';
import { createQuerySuggestionsPlugin } from '@algolia/autocomplete-plugin-query-suggestions';
import { createRedirectUrlPlugin } from '@algolia/autocomplete-plugin-redirect-url';
import cx from 'classnames';
import { createBreakpoint } from 'styled-components-breakpoint';
import { useSSR, useIntersectionObserver } from '@arcteryx/components-hooks';
import aa from 'search-insights';
import algoliasearch from 'algoliasearch/lite';
import { ProductTile as ProductTile$1 } from '@arcteryx/components-product-tile';
import '@algolia/autocomplete-theme-classic/dist/theme.css';

const SearchResultsContainer = styled.div`
  padding: 0 0.5rem 2rem;
  text-align: left;
  position: relative;
  z-index: 201;
  background-color: var(--white);
  top: -1px;
  p {
    max-width: initial;
  }
  ${Breakpoint("md")`
    padding: 0 0 2rem;
  `}
`;
const CountContainer = styled.div`
  max-width: 95.333rem;
  margin: auto;
  strong {
    font-family: var(--font-urw);
  }
  width: 98%;
  ${Breakpoint("sm")`
    width: 94%;
  `}
  ${Breakpoint("lg")`
    width: 88%;
  `}
`;
const Count = _ref => {
  let {
    nbHits,
    query
  } = _ref;
  return /*#__PURE__*/React.createElement(CountContainer, null, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(Trans, {
    ns: "container-search",
    i18nKey: "Search Result",
    values: {
      nbHits,
      query
    },
    components: [/*#__PURE__*/React.createElement("strong", null)]
  })));
};
const ResultCount = connectStats(Count);
const SearchResults = _ref2 => {
  let {
    query
  } = _ref2;
  return /*#__PURE__*/React.createElement(SearchResultsContainer, null, /*#__PURE__*/React.createElement(ResultCount, {
    query: query
  }));
};

styled.div`
  padding-top: 1rem;
  font-family: var(--font-helvetica) !important;
  font-size: 13px;
  line-height: 1.5em;
  overflow: auto;
  margin: auto;
  padding: 3em 1em 0;
  .search__no-results__query {
    color: var(--colour-black);
    margin: 0;
  }
  p {
    margin: auto;
  }
  h3 {
    text-transform: none;
  }
`;
const StyledBody1 = styled(Body1)`
  padding-left: 0.5rem;
  padding-right: 0.5rem;
`;
const StyledIframe = styled.iframe`
  display: block;
  border: none;
  height: 100vh;
  width: 100vw;
  margin-top: var(--space-green);
`;
const StyledDivNoResult = styled.div`
  overflow: auto;
  margin: auto;
  text-align: center;
  p {
    margin: auto;
  }
`;
const SearchNoResults = _ref => {
  let {
    query,
    cmsUrl
  } = _ref;
  const {
    t
  } = useTranslation("container-search");
  const {
    market
  } = useContext(SiteContext);
  const updateQuery = () => {
    const elem = document.querySelector(".search__no-results__query");
    if (elem) {
      elem.innerHTML = `"${query}"`;
    }
  };
  useEffect(() => {
    updateQuery();
  }, [query]);
  if (market === "leaf") {
    return null;
  }
  return /*#__PURE__*/React.createElement(StyledDivNoResult, null, /*#__PURE__*/React.createElement(StyledBody1, {
    alignment: TextAlignment$1.INHERIT
  }, t("showing results for")), /*#__PURE__*/React.createElement(H5, {
    alignment: TextAlignment$1.INHERIT,
    className: "search__no-results__query"
  }, query), /*#__PURE__*/React.createElement(StyledBody1, {
    alignment: TextAlignment$1.INHERIT
  }, t("We couldn't find any products that match your search.")), /*#__PURE__*/React.createElement(StyledBody1, {
    alignment: TextAlignment$1.INHERIT
  }, t("Here are a few alternate destinations that might help.")), cmsUrl && /*#__PURE__*/React.createElement(StyledIframe, {
    src: cmsUrl,
    title: "Search No Result"
  }));
};
SearchNoResults.propTypes = {
  query: PropTypes.string,
  cmsUrl: PropTypes.string
};

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$1() {
  _extends$1 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$1.apply(this, arguments);
}
function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties$1(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose$1(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

/* 
* Custom connectRefinementsApplied() will return the props:
* - refinements (all current refinements and sort)
* - refine (function to update the searchState on click events)
*/
const connectRefinementsApplied = createConnector({
  displayName: "ConnectedRefinementsApplied",
  getProvidedProps: (props, searchState, searchResults, metadata) => {
    const {
      sortBy: sortValue
    } = searchState || {};
    const {
      contextValue,
      indexContextValue,
      sortList
    } = props || {};
    // refinementList is taken from the Algolia connectCurrentRefinements function
    // https://github.com/algolia/instantsearch/blob/master/packages/react-instantsearch-core/src/connectors/connectCurrentRefinements.js#L25
    const refinementList = metadata.reduce((res, meta) => {
      if (typeof meta.items !== "undefined") {
        if (meta.id === "query") {
          return res;
        } else {
          return res.concat(meta.items.map(item => _objectSpread2(_objectSpread2({}, item), {}, {
            id: meta.id,
            index: meta.index
          })));
        }
      }
      return res;
    }, []);

    // check if the sort has been reset to the default index so we don't display it in the applied filters
    const hasSortValue = sortList.some(_ref => {
      let {
        value: replicaName
      } = _ref;
      return replicaName === sortValue;
    });
    // custom sortBy object, structure is similar to the filter facet items
    const sortBy = hasSortValue ? [{
      id: "sortBy",
      items: [{
        label: sortValue
      }],
      // emulating the clear value function built by Algolia
      value: state => {
        // we want to clear the sort by resetting to the default index
        const nextValue = {
          sortBy: contextValue.mainTargetedIndex
        };
        const resetPage = true;
        // pass in the searchState and use the refineValue function built by Algolia
        // https://github.com/algolia/instantsearch/blob/f802fd0f56d7e898c85e947fa6a3e5c11ff1b6ec/packages/react-instantsearch-core/src/core/indexUtils.js#L104
        return refineValue(state, nextValue, {
          ais: contextValue,
          multiIndexContext: indexContextValue
        }, resetPage);
      }
    }] : [];
    // merge refinementList and sortBy arrays
    const refinements = [].concat(...refinementList).concat(...sortBy);
    return {
      refinements
    };
  },
  refine(props, searchState, nextRefinement) {
    // `value` corresponds to our internal clear function computed in each connector metadata.
    const refinementsToClear = nextRefinement instanceof Array ? nextRefinement.map(item => item.value) : [nextRefinement];
    const newSearchState = refinementsToClear.reduce((res, clear) => {
      // we pass the searchState into the clear value function to clear the refinements and sort applied
      return clear(res);
    }, searchState);
    return newSearchState;
  }
});

const FilterAppliedBase = styled(props => /*#__PURE__*/React.createElement(FilterApplied, props))``;
const RefinementsApplied = _ref => {
  let {
    refinements,
    refine,
    sortList
  } = _ref;
  const {
    t
  } = useTranslation("container-search");
  const [activeFilters, setActiveFilters] = useState([]);
  useEffect(() => {
    const refinementsApplied = adaptRefinementsApplied({
      list: refinements,
      t,
      sortList
    });
    setActiveFilters(refinementsApplied);
  }, [refinements]);
  const refineFilter = _ref2 => {
    let {
      value
    } = _ref2;
    // if no clear value function, it is the handleResetAll click
    if (!value) {
      // pass in all refinements to be cleared by the refine function 
      // defined below in the custom connector
      refine(refinements);
      setActiveFilters([]);
      return;
    }
    refine(value);
  };
  if (activeFilters !== null && activeFilters !== void 0 && activeFilters.length) {
    return /*#__PURE__*/React.createElement(FilterAppliedBase, {
      activeFilters: activeFilters,
      handleFacetRemove: props => refineFilter(props),
      handleResetAll: props => refineFilter(props)
    });
  }
  return null;
};
const FilterRefinementsApplied = connectRefinementsApplied( /*#__PURE__*/React.memo(RefinementsApplied));

const buildAlgoliaIndex = _ref => {
  let {
    environment = "prod",
    // prod or preprod
    market = "outdoor",
    // outdoor, sale (outlet) or leaf
    country = "ca",
    language = "en"
  } = _ref;
  const lang = getLanguageFromLangCode(language).toLowerCase();
  return `${environment}_arcteryx_product_${market}_${country.toLowerCase()}_${lang}`;
};

// Algolia Analytics Tags Configuration: https://www.algolia.com/doc/guides/getting-insights-and-analytics/search-analytics/segmenting-your-analytics-data/#implementing-analytics-tags

const getPlatformTags = userAgent => {
  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
    return "platform:mobile";
  }
  return "platform:desktop";
};
const getURLTags = pathname => {
  var _pathname$match;
  /* eslint-disable */
  const [string, country, language, url] = (_pathname$match = pathname.match("^/([a-zA-Z]{2})/([a-zA-Z]{2})(/.*)?")) !== null && _pathname$match !== void 0 ? _pathname$match : [];
  /* eslint-enable */
  const tags = [];
  if (country) {
    tags.push(`country:${country}`);
  }
  if (language) {
    tags.push(`language:${language}`);
  }
  if (url) {
    tags.push(`url:${url}`);
  }
  return tags;
};
const getUserTags = function () {
  let cookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  if (cookies === null) {
    return;
  }
  const [visitedCookie] = decodeURIComponent(cookies).split(";").filter(cookie => cookie.indexOf("visited") >= 0);
  if (visitedCookie) {
    return "user:returning";
  }
  document.cookies = "visited=true";
  return "user:new";
};
const buildTagsArray = (userAgent, cookies, pathname) => [getPlatformTags(userAgent), getUserTags(cookies), ...getURLTags(pathname)].filter(item => typeof item !== "undefined");

const createURL = state => `?${qs.stringify(state)}`;

// Generates a secure UUID user token
const createUserToken = () => {
  const number = [1e7] + -1e3 + -4e3 + -8e3 + -1e11;
  const pattern = /[018]/g;
  const getRandomValue = () => {
    const array = new Uint8Array(1);
    crypto.getRandomValues(array);
    return array[0];
  };
  const replaceChar = char => {
    const randomValue = getRandomValue();
    return (char ^ randomValue & 15 >> char / 4).toString(16);
  };
  const token = number.toString().replace(pattern, replaceChar);
  return token;
};

const flipObject = obj => Object.fromEntries(Object.entries(obj).map(_ref => {
  let [key, value] = _ref;
  return [value, key];
}));

const facetCategoryMap = {
  gender: "gender",
  categories: "categories",
  collection: "collection",
  materials: "materials",
  "colors.BaseColor": "colours",
  review_value_rounded: "rating"
};

// flips the key and values in facetCategoryMap
const reverseFacetCategoryMap = flipObject(facetCategoryMap);

const languageMap = {
  en: 'english',
  fr: 'french',
  es: 'spanish',
  de: 'german',
  no: 'norwegian',
  zh: 'chinese',
  ja: 'japanese',
  jp: 'japanese'
};

// Store clicked items along with queryID to pass as conversion event on confirmation page
const persistConversionData = clickObj => {
  var _ref, _conversionData$userT;
  const conversionData = JSON.parse(sessionStorage.getItem("algolia-analytics-conversion"));
  const newConversionData = {
    queryID: clickObj.queryID,
    index: clickObj.index,
    objectIDs: Array.from(new Set(conversionData === null ? [...clickObj.objectIDs] : [...conversionData.objectIDs, ...clickObj.objectIDs])),
    positions: Array.from(new Set(conversionData === null ? [...clickObj.positions] : [...conversionData.positions, ...clickObj.positions])),
    userToken: (_ref = (_conversionData$userT = conversionData === null || conversionData === void 0 ? void 0 : conversionData.userToken) !== null && _conversionData$userT !== void 0 ? _conversionData$userT : clickObj === null || clickObj === void 0 ? void 0 : clickObj.userToken) !== null && _ref !== void 0 ? _ref : createUserToken()
  };
  sessionStorage.setItem("algolia-analytics-conversion", JSON.stringify(newConversionData));
  return newConversionData;
};

const spinalCase = word => word.replace(/\s+/g, "-").replace(/'/g, "-").replace(/\(/g, "-").replace(/\)/g, "-").toLowerCase();

/**
 * Algolia needs the query as a 'query' parameter, but requirements ask for the URL to show 'search'
 * so we rename the query value in the destructure here
 * and then set back in urlToSearchState using a replace on the generated string.
 * @param {object} location we use the pathname attribute
 * @param {object} searchState (algolia) destructured to { query<string>, refinementList<array>, sortBy<string>}
 * @param {array} sortList an array of objects that is created by the adaptSort in data-models
 * @returns {string} a URL path that looks like `pathname?search=beta&materials=insulated&sort=name-descending`
*/
const searchStateToUrl = function (location, _ref) {
  let {
    query: search,
    refinementList,
    sortBy
  } = _ref;
  let sortList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  const path = location !== null && location !== void 0 && location.pathname ? location.pathname : "";
  // format refinementList so we have nice looking filters
  let refinements = {};
  if (refinementList) {
    for (const [key, value] of Object.entries(refinementList)) {
      const category = facetCategoryMap[key];
      // change array into a string separated by commas
      refinements[category] = value.toString();
      // if category is empty, remove it from the URL
      if (value.length === 1 && value[0] === "" || !value.length) {
        delete refinements[category];
      }
    }
  }
  // we want to change how sort looks in the URL
  // from: sortBy=prod_arcteryx_product_outdoor_ca_english_name_desc
  // to: sort=name-descending
  // create an empty object so that if there isn't a match below then sort will disappear from the URL
  let sortOption = {};
  // find the replicaName in the sortList which is created from the adaptSort function
  const sortReplicaMatch = sortList === null || sortList === void 0 ? void 0 : sortList.find(_ref2 => {
    let {
      value: replicaName
    } = _ref2;
    return replicaName === sortBy;
  });
  if (sortReplicaMatch) {
    // use the id attribute which is formatted like name-descending etc.
    sortOption = {
      sort: sortReplicaMatch.id
    };
  }
  // create a nice URL path
  return search ? `${path}${createURL(_objectSpread2(_objectSpread2({
    search
  }, refinements), sortOption))}` : "";
};

const sanitizeString = str => {
  const decodedStr = decodeURIComponent(str);
  return decodedStr.replace(/<[^>]+>/ig, "");
};

/**
 * urlToSearchState() - takes the URL of the search and formats it into an object that Algolia can use to keep the query, filters and sort persisting
 * @param {object} location - object that is destructured to so we get the search query params
 * @param {string} indexName - name of the search index for sort values
 * @returns {object} searchState
 */
const urlToSearchState = function (_ref) {
  let {
    search
  } = _ref;
  let sortList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let searchState = {};
  const searchObject = qs.parse(search);
  for (const [key, value] of Object.entries(searchObject)) {
    if (key === "?search") {
      searchState.query = sanitizeString(value);
    }
    // reverse lookup the facet category map
    if (reverseFacetCategoryMap[key]) {
      searchState.refinementList = _objectSpread2(_objectSpread2({}, searchState.refinementList), {}, {
        // change value back into an array
        [reverseFacetCategoryMap[key]]: sanitizeString(value).split(',')
      });
    }
    if (key === "sort") {
      var _sortList$find;
      const sortValue = (sortList === null || sortList === void 0 ? void 0 : (_sortList$find = sortList.find(_ref2 => {
        let {
          id
        } = _ref2;
        return id === value;
      })) === null || _sortList$find === void 0 ? void 0 : _sortList$find.value) || "";
      searchState.sortBy = sanitizeString(sortValue);
    }
  }
  return searchState;
};

const isOrContainsNode = (parent, child) => {
  return parent === child || parent.contains(child);
};
const onMouseDownOrTouchStart = _ref => {
  let {
    event,
    searchBoxElem,
    searchPanelElem,
    setIsOpen
  } = _ref;
  if (!searchPanelElem || !searchPanelElem.hasChildNodes()) {
    return;
  }
  const isTargetWithinAutocomplete = [searchBoxElem, searchPanelElem].some(function (contextNode) {
    return isOrContainsNode(contextNode, event.target);
  });
  const inputBox = searchBoxElem.querySelector("input");
  if (isTargetWithinAutocomplete === false && inputBox.value) {
    setIsOpen(true);
  } else {
    inputBox.blur();
  }
};

const RefinementListBase = styled.li`
  padding: 0;
`;
const FitlerTitleBase = styled(props => /*#__PURE__*/React.createElement(FilterTitle, props))`
  white-space: nowrap;
  @media screen and (max-width: ${ScreenSize$1.xl}px) {
    display: flex;
    justify-content: center;
    padding: 0 0.866rem 0 1rem !important;
    span {
      justify-content: space-between;
      padding: 0.766rem 0px !important;
      width: 100% !important;
      &:after {
        content: "+";
        line-height: 1;
        float: right;
        position: initial;
        transform-origin: center;
        top: 50%;
        font-family: var(--font-urw);
        transform: rotate(0deg);
      }
    }

    &:before {
      display: none;
    }

    &.active {
      span {
        &:after {
          transform: rotate(-45deg) !important;
        }
      }
    }
  }
`;
const FilterDropdownBase = styled(props => /*#__PURE__*/React.createElement(FilterDropdown, props))`
  @media screen and (min-width: calc(${ScreenSize$1.xl}px + 1px)) and (max-width: 1300px) {
    ul {
      width: 550px;
    }
  }
  @media screen and (max-width: ${ScreenSize$1.xl}px) {
    position: relative;
    top: -1px;
    left: 0;
    ul {
      margin: 0 !important;
    }
  }
  &:before, &:after {
    top: 0 !important;
    height: 100% !important;
  }
  ul {
    margin-bottom: 0 !important;
    padding-bottom: 1.333rem !important;
    label {
      white-space: nowrap;
    }
  }
  &.active {
    ul {
      position: relative;
      z-index: 30;
    }
  }
`;

/* 
* Algolia function connectRefinementList() will return the props:
* - attribute (DOM annotation)
* - items (all available facets of an attribute)
* - refine (function to update the search on user selection)
*/
const RefinementList = _ref => {
  var _items$filter;
  let {
    attribute,
    items,
    refine,
    context,
    isActive,
    handleSetActiveCategory,
    handleSetActiveFilters
  } = _ref;
  const {
    t
  } = useTranslation("container-search");
  const activeFacets = items === null || items === void 0 ? void 0 : (_items$filter = items.filter(item => item.isRefined)) === null || _items$filter === void 0 ? void 0 : _items$filter.map(item => {
    var _item$label;
    return _objectSpread2(_objectSpread2({}, item), {}, {
      catId: attribute,
      id: (_item$label = item.label) === null || _item$label === void 0 ? void 0 : _item$label.toLowerCase()
    });
  });
  const toggleFilters = () => {
    handleSetActiveFilters(isActive ? null : attribute);
    handleSetActiveCategory(isActive ? null : attribute);
  };
  const refineFilter = useCallback(val => {
    const currentItem = items === null || items === void 0 ? void 0 : items.find(item => (item === null || item === void 0 ? void 0 : item.label.toLowerCase()) === (val === null || val === void 0 ? void 0 : val.id.toLowerCase()));
    const value = currentItem === null || currentItem === void 0 ? void 0 : currentItem.value;
    refine(value);
    handleSetActiveFilters(null);
    handleSetActiveCategory(null);
  }, [items]);
  const dropdownItems = useMemo(() => {
    const itemsWithId = items === null || items === void 0 ? void 0 : items.map(item => {
      var _item$label2;
      return _objectSpread2(_objectSpread2({}, item), {}, {
        id: (_item$label2 = item.label) === null || _item$label2 === void 0 ? void 0 : _item$label2.toLowerCase()
      });
    });
    if ((attribute === null || attribute === void 0 ? void 0 : attribute.toLowerCase()) === "review_value_rounded") {
      return itemsWithId.sort((a, b) => b.label - a.label);
    }
    return itemsWithId;
  }, [items, attribute]);
  if (items !== null && items !== void 0 && items.length) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RefinementListBase, {
      className: `arc-Filter arc-Filter--Filter ${isActive ? "activeFilter" : ""}`
    }, /*#__PURE__*/React.createElement(FitlerTitleBase, {
      className: "filter-title",
      catId: attribute,
      label: t(facetCategoryMap[attribute]),
      isActive: isActive,
      activeFacets: activeFacets,
      handleCategoryChange: toggleFilters
    }), /*#__PURE__*/React.createElement(FilterDropdownBase, {
      context: context,
      catId: attribute,
      items: dropdownItems,
      hasChildren: false,
      isActive: isActive,
      activeFacets: activeFacets,
      handleFacetClick: refineFilter,
      urlParam: attribute
    })));
  }
  return null;
};
const FilterRefinementList = connectRefinementList( /*#__PURE__*/React.memo(RefinementList));

const _excluded$2 = ["facets", "selectedFacets", "activeCategory", "activeFilters"];
const RefineCategoryTitle = styled(props => /*#__PURE__*/React.createElement(FilterTitle, props))`
  width: 50%;
  ${Breakpoint("sm")`
    width: 40%
  `}
  ${Breakpoint("lg")`
    width: initial;
  `} 
  @media only screen and (min-width: calc(${ScreenSize$1.xl}px + 1px)) {
    display: none;
  }

  .filter-title-label {
    ${props => props.refineFacetSelected ? `text-decoration: underline;` : ""}
  }
`;
const RefineDropdownContainer = styled.ul`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  max-height: 0;
  opacity: 0;
  pointer-events: none;
  background-color: var(--white);
  position: absolute;
  z-index: 2;
  top: 2.34rem;
  left: 0;
  @media only screen and (min-width: calc(${ScreenSize$1.xl}px + 1px)) {
    position: relative;
    top: 0;
    max-width: 40ch;
    flex-direction: row;
    justify-content: space-between;
    max-height: 100%;
    opacity: 1;
    pointer-events: auto;
  }
  &:before {
    content: "";
    background-color: var(--white);
    width: 5000%;
    height: 100%;
    position: absolute;
    left: -500%;
    top: 0;
    z-index: 3;
  } 

  .arc-Filter {
    opacity: 0;
    pointer-events: none;
    position: relative;
    @media only screen and (min-width: calc(${ScreenSize$1.xl}px + 1px)) {
      opacity: 1;
      pointer-events: auto;
    }

    @media screen and (max-width: ${ScreenSize$1.xl}px) {
      &:first-of-type {
        .filter-title {
          span {
            border-top-width: 0;
          }
        }
      }

      &:last-of-type {
        .filter-title {
          border-bottom: 0.066rem solid var(--colour-grey-pinline);
        }
      }
    }
  }

  &.activeCategory, &.activeFilter {
    max-height: 107.333rem;
    opacity: 1;
    pointer-events: auto;
    ${Breakpoint("xl")`
      max-height: 100rem;
    `}
    .arc-Filter {
      opacity: 1;
      pointer-events: auto;
    }
  }
`;
const FilterRefineCategory = _ref => {
  let {
      facets = [],
      selectedFacets,
      activeCategory,
      activeFilters
    } = _ref,
    props = _objectWithoutProperties$1(_ref, _excluded$2);
  const [refineFacetSelected, setRefineFacetSelected] = useState(false);
  const {
    handleSetActiveCategory,
    handleSetActiveFilters
  } = props;
  const {
    t
  } = useTranslation("container-search");
  const catId = "refine";
  const label = t("Refine");
  const isRefineActive = activeCategory === catId;

  // this useEffect checks the selectedFacets to see if there are any active
  // and then sets the state of refineFacetSelected as true or false
  // this controls the underline of the "Refine" filter title
  useEffect(() => {
    for (const [key, value] of Object.entries(selectedFacets)) {
      if (Array.isArray(value) && value.length) {
        setRefineFacetSelected(true);
      } else {
        setRefineFacetSelected(false);
      }
    }
  }, [selectedFacets]);
  const handleRefineChange = () => {
    handleSetActiveFilters(isRefineActive ? null : catId);
    handleSetActiveCategory(isRefineActive ? null : catId);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RefineCategoryTitle, {
    catId: catId,
    label: label,
    isActive: isRefineActive,
    className: "filter-category-title",
    refineFacetSelected: refineFacetSelected,
    handleCategoryChange: handleRefineChange
  }), /*#__PURE__*/React.createElement(RefineDropdownContainer, {
    className: `${activeCategory && activeCategory !== "sort" ? "activeCategory" : ""}`
  }, facets === null || facets === void 0 ? void 0 : facets.map(_ref2 => {
    let {
      name
    } = _ref2;
    return /*#__PURE__*/React.createElement(FilterRefinementList, _extends$1({
      key: name,
      attribute: name,
      isActive: activeFilters === name,
      limit: 100
    }, props));
  })));
};

const FilterTitleBase = styled(props => /*#__PURE__*/React.createElement(FilterTitle, props))``;
const StyledSortBy = styled(props => /*#__PURE__*/React.createElement(Sort, props))`
  width: 50%;
  ${Breakpoint("sm")`
    width: 40%
  `}
  ${Breakpoint("lg")`
    width: initial;
  `}
  &.activeCategory, &.activeFilter {
    max-height: 107.333rem;
    opacity: 1;
    pointer-events: auto;
    ${Breakpoint("xl")`
      max-height: 100rem;
    `}
    .arc-Filter {
      opacity: 1;
      pointer-events: auto;
    }
  }
`;

/* 
* Algolia function connectSortBy() will return the props:
* - attribute (DOM annotation)
* - items (all available facets of an attribute)
* - refine (function to update the search on user selection)
*/
const SortBy = _ref => {
  var _items$filter;
  let {
    attribute,
    items,
    refine,
    activeCategory,
    handleSetActiveFilters,
    handleSetActiveCategory
  } = _ref;
  const {
    t
  } = useTranslation("container-search");
  const isActive = activeCategory === attribute;
  const filterTitleToggle = () => {
    handleSetActiveFilters(isActive ? null : attribute);
    handleSetActiveCategory(isActive ? null : attribute);
  };
  const refineFilter = useCallback(val => {
    const currentItem = items === null || items === void 0 ? void 0 : items.find(item => (item === null || item === void 0 ? void 0 : item.id.toLowerCase()) === (val === null || val === void 0 ? void 0 : val.id.toLowerCase()));
    const value = currentItem === null || currentItem === void 0 ? void 0 : currentItem.value;
    const name = currentItem === null || currentItem === void 0 ? void 0 : currentItem.id;
    refine(value);
    handleSetActiveFilters(isActive ? null : name);
    handleSetActiveCategory(null);
  }, [items]);
  const activeFacets = items === null || items === void 0 ? void 0 : (_items$filter = items.filter(item => item.isRefined)) === null || _items$filter === void 0 ? void 0 : _items$filter.map(item => _objectSpread2(_objectSpread2({}, item), {}, {
    catId: attribute
  }));
  return /*#__PURE__*/React.createElement(StyledSortBy, {
    className: `${isActive ? "active" : ""}`,
    catId: spinalCase(attribute)
  }, /*#__PURE__*/React.createElement(FilterTitleBase, {
    className: "filter-category-title",
    catId: attribute,
    label: t("Sort"),
    isActive: isActive,
    activeFacets: activeFacets,
    handleCategoryChange: filterTitleToggle
  }), /*#__PURE__*/React.createElement(FilterDropdown, {
    context: "sort",
    catId: attribute,
    items: items,
    hasChildren: false,
    isActive: isActive,
    activeFacets: activeFacets,
    handleFacetClick: refineFilter
  }));
};
const FilterSortBy = connectSortBy( /*#__PURE__*/React.memo(SortBy));

/* 
* Algolia function createConnector() provides a UI and a connector to hook up our own UI 
*/
const connectFilterBar = createConnector({
  displayName: "ConnectedFilterBar",
  getProvidedProps: (props, searchState, searchResults) => {
    var _searchResults$result, _searchResults$result2, _searchResults$result3, _searchResults$result4, _searchResults$result5, _props$contextValue;
    return {
      facets: !searchResults.searching && searchResults !== null && searchResults !== void 0 && (_searchResults$result = searchResults.results) !== null && _searchResults$result !== void 0 && _searchResults$result.nbHits && searchState.refinementList && // use default facets when there's no refinement list to avoid facets re-rendering
      searchResults !== null && searchResults !== void 0 && (_searchResults$result2 = searchResults.results) !== null && _searchResults$result2 !== void 0 && (_searchResults$result3 = _searchResults$result2.disjunctiveFacets) !== null && _searchResults$result3 !== void 0 && _searchResults$result3.length ? searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$result4 = searchResults.results) === null || _searchResults$result4 === void 0 ? void 0 : _searchResults$result4.disjunctiveFacets : undefined,
      selectedFacets: searchState === null || searchState === void 0 ? void 0 : searchState.refinementList,
      itemCount: searchResults === null || searchResults === void 0 ? void 0 : (_searchResults$result5 = searchResults.results) === null || _searchResults$result5 === void 0 ? void 0 : _searchResults$result5.nbHits,
      currentSort: searchState === null || searchState === void 0 ? void 0 : searchState.sortBy,
      indexName: props === null || props === void 0 ? void 0 : (_props$contextValue = props.contextValue) === null || _props$contextValue === void 0 ? void 0 : _props$contextValue.mainTargetedIndex
    };
  }
});

const FilterBarContainer = styled(props => /*#__PURE__*/React.createElement(FilterBarBase, props))`
  top: -2px;
  * {
    box-sizing: border-box!important;
  }
  .arc-Filter--Filter {
    div[class*=" filter-dropdown_"], div[class*="filter-title"]  {
      z-index: 100;
      background-color: var(--white);
    }
  }
  .item-count {
    z-index: 100;
    background-color: var(--white);
  }
  .filter-category-title {
    z-index: 100;
    background-color: var(--white);
    ${Breakpoint("xl")`
      border-bottom-width: 0;
    `}
  }
`;
const FilterBarWrapperBase = styled(props => /*#__PURE__*/React.createElement(FilterBarWrapper, props))`
  width: 98%;
  ${Breakpoint("sm")`
    width: 94%;
  `}
  ${Breakpoint("lg")`
    width: 88%;
  `}
`;
const ItemCountBase = styled(props => /*#__PURE__*/React.createElement(ItemCount, props))``;
const Overlay = styled.div`
  content: "";
  width: 300%;
  height: 100vh;
  overflow: hidden;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
`;
const FilterBarUnconnected = _ref => {
  let {
    facets = [{
      name: "gender",
      data: {
        mocked: 0
      }
    }, {
      name: "collection",
      data: {
        mocked: 0
      }
    }, {
      name: "categories",
      data: {
        mocked: 0
      }
    }, {
      name: "materials",
      data: {
        mocked: 0
      }
    }, {
      name: "colors.BaseColor",
      data: {
        mocked: 0
      }
    }, {
      name: "review_value_rounded",
      data: {
        mocked: 0
      }
    }],
    selectedFacets = {
      gender: "",
      collection: "",
      categories: "",
      materials: "",
      "colors.BaseColor": "",
      review_value_rounded: ""
    },
    itemCount = 0,
    indexName
  } = _ref;
  const {
    t
  } = useTranslation("container-search");
  // Keep these comments - used for i18next-parser
  // t("gender")
  // t("categories")
  // t("collection")
  // t("properties")
  // t("materials")
  // t("colours")
  // t("rating")
  // t("In Stock")
  // t("Refine")
  // t("Items")
  // t("MALE")
  // t("FEMALE")
  // t("NEUTRAL")
  // t("natural")
  // t("Name (A→Z)")
  // t("Name (Z→A)")
  // t("What's New")
  // t("Top Rated")
  // t("Weight (Low→High)")
  // t("Price (Low→High)")
  // t("Price (High→Low)")
  // t("Search Result")

  const [activeCategory, setActiveCategory] = useState(null);
  const [activeFilters, setActiveFilters] = useState(null);
  const handleSetActiveFilters = useCallback(val => setActiveFilters(val), []);
  const handleSetActiveCategory = useCallback(val => setActiveCategory(val), []);
  const {
    market
  } = useContext(SiteContext);
  const sort = adaptSort(indexName, market);
  // calculate facets only once on mount to avoid re-render and algolia api calls with result facets
  const filteredFacets = useMemo(() => {
    let filteredFacets;
    switch (market) {
      case "outdoor":
        filteredFacets = facets;
        break;
      case "outlet":
        filteredFacets = facets.filter(facet => facet.name !== "review_value_rounded");
        break;
      case "leaf":
        filteredFacets = facets.filter(facet => facet.name !== "review_value_rounded" && facet.name !== "materials" && facet.name !== "collection" && facet.name !== "activities");
        break;
      default:
        filteredFacets = facets;
    }
    return filteredFacets;
  }, []);
  const handleOverlayClick = () => {
    setActiveFilters(null);
    setActiveCategory(null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(FilterBarContainer, {
    isActive: activeFilters
  }, /*#__PURE__*/React.createElement(FilterBarWrapperBase, {
    className: `${activeFilters || activeCategory ? "active" : ""}`
  }, /*#__PURE__*/React.createElement(ItemCountBase, {
    productCount: itemCount,
    catId: "items",
    label: t("Items"),
    className: "item-count"
  }), /*#__PURE__*/React.createElement(FilterRefineCategory, {
    context: "filter",
    facets: filteredFacets,
    selectedFacets: selectedFacets,
    activeFilters: activeFilters,
    activeCategory: activeCategory,
    handleSetActiveFilters: handleSetActiveFilters,
    handleSetActiveCategory: handleSetActiveCategory
  }), sort && /*#__PURE__*/React.createElement(FilterSortBy, {
    defaultRefinement: indexName,
    attribute: sort === null || sort === void 0 ? void 0 : sort.id,
    items: sort === null || sort === void 0 ? void 0 : sort.items,
    activeFilters: activeFilters,
    activeCategory: activeCategory,
    handleSetActiveFilters: handleSetActiveFilters,
    handleSetActiveCategory: handleSetActiveCategory
  }))), /*#__PURE__*/React.createElement(FilterRefinementsApplied, {
    sortList: sort === null || sort === void 0 ? void 0 : sort.items,
    indexName: indexName
  }), activeFilters || activeCategory ? /*#__PURE__*/React.createElement(Overlay, {
    className: "overlay",
    onClick: handleOverlayClick
  }) : "");
};
const FilterBar = connectFilterBar( /*#__PURE__*/React.memo(FilterBarUnconnected));

// Used to populate aloglia index field when sending events to algolia Analytics, and pass down adoebe analytics events
const IndexContext = /*#__PURE__*/React.createContext({});
const IndexContextProvider = _ref => {
  let {
    index,
    analyticsEvents,
    algoliaClient,
    environment,
    suggestedSearch,
    setSuggestedSearch,
    suggestedSearchContext,
    setSuggestedSearchContext,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(IndexContext.Provider, {
    value: {
      index,
      analyticsEvents,
      algoliaClient,
      suggestedSearch,
      environment,
      setSuggestedSearch,
      suggestedSearchContext,
      setSuggestedSearchContext
    }
  }, children);
};

const SearchBoxWrapper = styled.div`
  flex: 1 1 auto;
  max-width: 100%;
  .aa-InputWrapperSuffix {
    display: none;
  }
  .aa-InputWrapperPrefix {
    order: 4;
  }
  .aa-Input {
    padding: 1rem;
    box-sizing: border-box;
    ${Body1Styles$1};
  }
  .aa-Form {
    border: 1px solid #707070;
    padding: 0;
    font-family: var(--font-helvetica);
    box-sizing: border-box;
    border-radius: 0;
    &:focus-within {
      border: 1px solid #707070;
      box-shadow: none;
    }
  }
  .aa-Label svg {
    color: var(--colour-copy);
  }
`;
const CustomSearchBox = _ref => {
  let {
    refine,
    currentRefinement,
    delay,
    autoFocus,
    searchPanelRef
  } = _ref;
  const {
    t
  } = useTranslation("container-search");
  const [value, setValue] = useState(currentRefinement);
  const timerIdRef = useRef(null);
  const {
    algoliaClient,
    setSuggestedSearch,
    environment,
    setSuggestedSearchContext,
    index
  } = useContext(IndexContext);
  const searchBoxRef = useRef(null);
  const {
    market,
    language
  } = useContext(SiteContext);
  const FACETS = ["gender", "collection", "categories", "materials", "colors.BaseColor", "review_value_rounded"];
  const onChangeDebounced = query => {
    const inputValue = sanitizeString(query);
    clearTimeout(timerIdRef.current);
    timerIdRef.current = setTimeout(() => refine(inputValue), delay);
    setValue(inputValue);
  };
  useEffect(() => {
    if (!searchBoxRef.current || !searchPanelRef.current) {
      return undefined;
    }
    const querySuggestionsPlugin = createQuerySuggestionsPlugin({
      searchClient: algoliaClient,
      indexName: `${environment}_arcteryx_product_${market}_${languageMap[language]}_query_suggestions`,
      getSearchParams: () => ({
        hitsPerPage: 3
      }),
      transformSource: _ref2 => {
        let {
          source
        } = _ref2;
        return _objectSpread2(_objectSpread2({}, source), {}, {
          templates: _objectSpread2(_objectSpread2({}, source.templates), {}, {
            item(_ref3) {
              let {
                item,
                components,
                html
              } = _ref3;
              return html`<div>${components.Highlight({
                hit: item,
                attribute: "query",
                tagName: "strong"
              })}</div>`;
            }
          })
        });
      }
    });
    const redirectUrlPlugin = createRedirectUrlPlugin();
    const search = autocomplete({
      container: searchBoxRef.current,
      panelContainer: searchPanelRef.current,
      plugins: market === "leaf" ? [] : [querySuggestionsPlugin, redirectUrlPlugin],
      placeholder: t("Search"),
      insights: true,
      detachedMediaQuery: "none",
      initialState: {
        query: value || ""
      },
      onStateChange(props) {
        const {
          state,
          prevState,
          setContext
        } = props;
        if (prevState.query !== state.query) {
          // item is selected from query suggestions
          if (state.activeItemId !== null) {
            var _state$collections;
            const querySuggestionCollection = (_state$collections = state.collections) === null || _state$collections === void 0 ? void 0 : _state$collections.find(item => {
              var _item$source;
              return (item === null || item === void 0 ? void 0 : (_item$source = item.source) === null || _item$source === void 0 ? void 0 : _item$source.sourceId) === "querySuggestionsPlugin";
            });
            const suggestedItems = (querySuggestionCollection === null || querySuggestionCollection === void 0 ? void 0 : querySuggestionCollection.items) || [];
            setContext({
              searchTermSuggested: state.query,
              searchTermEntered: prevState.query,
              staticTerm: null,
              termCount: String(suggestedItems.length),
              terms: suggestedItems === null || suggestedItems === void 0 ? void 0 : suggestedItems.map(item => ({
                term: item.query
              }))
            });
          } else {
            setContext({
              searchTermSuggested: undefined,
              searchTermEntered: undefined,
              staticTerm: undefined,
              termCount: undefined,
              terms: undefined
            });
          }
        }
        setSuggestedSearchContext(state.context);
      },
      getSources(props) {
        const {
          state
        } = props;
        return [{
          sourceId: "products",
          getItems(_ref4) {
            let {
              query,
              setContext
            } = _ref4;
            return getAlgoliaResults({
              searchClient: algoliaClient,
              queries: [{
                indexName: index,
                params: {
                  query,
                  hitsPerPage: 999,
                  facets: FACETS
                }
              }],
              transformResponse(_ref5) {
                let {
                  results
                } = _ref5;
                setContext({
                  results
                });
                onChangeDebounced(state.query);
                return [];
              }
            });
          },
          templates: {
            item() {
              return null;
            }
          }
        }];
      }
    });
    setSuggestedSearch(search);

    // set auto focus
    if (autoFocus) {
      const inputBox = searchBoxRef.current.querySelector("input");
      inputBox === null || inputBox === void 0 ? void 0 : inputBox.focus();
    }
    const handleOnMouseDownOrTouchStart = e => onMouseDownOrTouchStart({
      event: e,
      searchBoxElem: searchBoxRef.current,
      searchPanelElem: searchPanelRef.current,
      setIsOpen: search.setIsOpen
    });
    // Override autocomplete default click/touch event and keep search panel open
    // https://www.algolia.com/doc/ui-libraries/autocomplete/guides/creating-a-renderer/#mirroring-a-native-mobile-experience
    window.addEventListener("mousedown", handleOnMouseDownOrTouchStart);
    window.addEventListener("touchstart", handleOnMouseDownOrTouchStart);
    window.addEventListener("touchmove", handleOnMouseDownOrTouchStart);
    return () => {
      search.destroy();
    };
  }, []);
  return /*#__PURE__*/React.createElement(SearchBoxWrapper, {
    ref: searchBoxRef
  });
};
const SearchBox = connectSearchBox(CustomSearchBox);

const connectSearchBar = createConnector({
  displayName: "ConnectedSearchBar",
  getProvidedProps: (props, searchState, searchResults) => {
    var _props$contextValue;
    return {
      query: searchState === null || searchState === void 0 ? void 0 : searchState.query,
      store: props === null || props === void 0 ? void 0 : (_props$contextValue = props.contextValue) === null || _props$contextValue === void 0 ? void 0 : _props$contextValue.store,
      searchResults,
      searchState,
      props
    };
  }
});

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
const LoadingIcon = styled.span`
  position: absolute;
  left: 50%;
  top: 50%;
  @keyframes sendingToLambda {
    to {
      transform: rotate(360deg);
    }
  }
  &:after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    border: 2px solid var(--pinline-grey);
    border-top-color: var(--dark-grey);
    animation: sendingToLambda 0.6s linear infinite;
    margin-left: -10px;
    margin-top: -10px;
  }
`;
const SUBTLE = "Subtle";
const INVERTED = "Inverted";
const SECONDARY = "Secondary-cta";
const SECURE = "Secure-Checkout";
const ADDTOCART = "Add-To-Cart";
const EMAIL = "Email";
const FINDINSTORE = "Find-In-Store";
const STANDARD = "Standard";
const widthValue = _ref => {
  let {
    width,
    context
  } = _ref;
  if (width) {
    return `${width}`;
  }
  switch (context) {
    case ADDTOCART:
    case EMAIL:
    case SECURE:
      return "100%;";
    default:
      return "auto";
  }
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}
var ScreenSize;
(function (ScreenSize) {
  ScreenSize[ScreenSize["xs"] = 0] = "xs";
  ScreenSize[ScreenSize["sm"] = 576] = "sm";
  ScreenSize[ScreenSize["md"] = 768] = "md";
  ScreenSize[ScreenSize["lg"] = 992] = "lg";
  ScreenSize[ScreenSize["xl"] = 1200] = "xl";
  ScreenSize[ScreenSize["xxl"] = 1440] = "xxl";
})(ScreenSize || (ScreenSize = {}));
createBreakpoint({
  xs: ScreenSize.xs,
  sm: ScreenSize.sm,
  md: ScreenSize.md,
  lg: ScreenSize.lg,
  xl: ScreenSize.xl,
  xxl: ScreenSize.xxl
});
var TextAlignment;
(function (TextAlignment) {
  TextAlignment["LEFT"] = "left";
  TextAlignment["CENTER"] = "center";
  TextAlignment["RIGHT"] = "right";
  TextAlignment["INHERIT"] = "inherit";
})(TextAlignment || (TextAlignment = {}));
var Variant;
(function (Variant) {
  Variant["SMALL"] = "small";
  Variant["MEDIUM"] = "medium";
  Variant["XLARGE"] = "extra-large";
  Variant["PRIMARY"] = "primary";
  Variant["LINK"] = "link";
})(Variant || (Variant = {}));
Object.values(TextAlignment);
Object.values(Variant);
const H1Styles = props => {
  var _a, _b;
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.LEFT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  let desktopFontSize = "3.25rem";
  let mobileFontSize = "2.625rem";
  switch (props.variant) {
    case Variant.SMALL:
      desktopFontSize = "1.625rem";
      mobileFontSize = "1.5rem";
      break;
    case Variant.MEDIUM:
      desktopFontSize = "2rem";
      mobileFontSize = "1.75rem";
      break;
  }
  return css`
  font-family: var(--font-elan);
  font-size: ${desktopFontSize};
  font-weight: 400;
  line-height: 1;
  text-transform: uppercase;
  text-align: ${textAlign};
  color: ${color};
  margin-bottom: 0;
  
  @media (max-width: ${ScreenSize.md}px) {
    font-size: ${mobileFontSize};
  }
  `;
};
styled.h1`
  ${H1Styles}
`;
const H2Styles = props => {
  var _a, _b;
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.LEFT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  const desktopFontSize = props.variant && props.variant === Variant.XLARGE ? "3.25rem" : "2.375rem";
  const mobileFontSize = props.variant && props.variant === Variant.XLARGE ? "2.25rem" : "1.875rem";
  const desktopLetterSpacing = props.variant && props.variant === Variant.XLARGE ? "0.0325rem" : "0.02375rem";
  const mobileLetterSpacing = props.variant && props.variant === Variant.XLARGE ? "0.0225rem " : "0.01875rem";
  return css`
    font-family: var(--font-helvetica);
    font-size: ${desktopFontSize};
    font-weight: 300;
    line-height: 1.15;
    letter-spacing: ${desktopLetterSpacing};
    text-transform: initial;
    text-align: ${textAlign};
    color: ${color};
    margin-bottom: 0;
  
    @media (max-width: ${ScreenSize.md}px) {
      font-size: ${mobileFontSize};
      line-height: 1.2;
      letter-spacing: ${mobileLetterSpacing};
    }
  `;
};
styled.h2`
  ${H2Styles};
`;
const H3Styles = props => {
  var _a, _b;
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.LEFT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  return css`
    font-family: var(--font-helvetica);
    font-size: 1.75rem;
    font-weight: 400;
    line-height: 1.35;
    text-transform: initial;
    text-align: ${textAlign};
    color: ${color};
    margin-bottom: 0;

    @media (max-width: ${ScreenSize.md}px) {
      font-size: 1.5rem;
    }
  `;
};
styled.h3`
  ${H3Styles}
`;
const H4Styles = props => {
  var _a, _b;
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.LEFT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  return css`
    font-family: var(--font-elan);
    font-size: 1.375rem;
    font-weight: 400;
    line-height: 1.2;
    text-transform: uppercase;
    text-align: ${textAlign};
    color: ${color};
    margin-bottom: 0;

    @media (max-width: ${ScreenSize.md}px) {
      font-size: 1.25rem;
      line-height: 1.2;
    }
  `;
};
styled.h4`
  ${H4Styles};
`;
const H5Styles = props => {
  var _a, _b;
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.LEFT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  return css`
    font-family: var(--font-helvetica);
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 1.4;
    text-transform: initial;
    text-align: ${textAlign};
    color: ${color};
    margin-top: 0;
    margin-bottom: 0;
    //  TODO: update with proper screen size breakpoint
    @media (max-width: ${ScreenSize.sm}px) {
      font-size: 1.25rem;
    }
  `;
};
styled.h5`
  ${H5Styles}
`;
const H6Styles = props => {
  var _a, _b;
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.LEFT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  return css`
    font-family: var(--font-helvetica);
    font-size: 1.25rem;
    font-weight: 400;
    line-height: 1.2;
    letter-spacing: 0.0375rem;
    text-transform: uppercase;
    text-align: ${textAlign};
    color: ${color};
    margin-top: 0;
    margin-bottom: 0;

    @media (max-width: ${ScreenSize.md}px) {
      font-size: 1.125rem;
      letter-spacing: 0.03375rem;
    }
  `;
};
styled.h6`
  ${H6Styles}
`;
const fontSize = size => {
  if (size === "s") {
    return "0.75rem";
  }
  if (size === "m") {
    return "1.1rem";
  }
  if (size === "l") {
    return "1.25rem";
  }
  return "1rem";
};
const P = styled.p`
  margin: 0 0 1.5rem 0;
  font-family: ${props => ["urban", "veilance"].includes(props.market.toLowerCase()) ? '"Suisse Intl Regular", arial, sans-serif' : '"urw-din", arial, sans-serif'};
  font-size: ${props => fontSize(props.size)};
  font-weight: ${props => props.bold ? `600` : `400`};
  font-style: ${props => props.italic ? `italic` : `normal`};
  line-height: ${props => props.size === "s" ? `1rem` : `1.5rem`};
  color: ${props => props.textColor};
  text-decoration: ${props => props.textDecoration};

  strong,
  b {
    font-weight: 500;
  }

  em,
  i {
    font-weight: 400;
    font-style: italic;
  }

  &:last-of-type {
    margin-bottom: 0;
  }
`;
P.defaultProps = {
  large: false,
  textColor: "var(--colour-copy)",
  textDecoration: "none",
  market: "outdoor"
};
const DefaultBodyStyles = props => {
  var _a, _b;
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.LEFT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  return css`
    max-width: 75ch;
    font-family: var(--font-helvetica);
    text-transform: initial;
    text-align: ${textAlign};
    color: ${color};
    margin: 0;
    position: relative;
  `;
};
const bodyType = ["body4", "body5", "body6"];
const FontLinkAfterStyle = type => {
  return `
    content: "";
    position: absolute;
    left: 0;
    width: 0;

    // TODO: use this when we switch to new fonts
    // bottom: ${bodyType.includes(type) ? "5px" : "6px"};
    bottom: 2px;
    
    background-color: currentColor;
    height: 1px;
    transition-property: width;
    transition-duration: 0.3s;
    transition-timing-function: ease-out;
  `;
};
const FontLinkHoverStyle = `
    width: 100%;
`;
const FontLinkStyle = type => {
  return `
  text-decoration: none;
  position: relative;
  display: block;
  width: fit-content;
   
  &::after {
    ${FontLinkAfterStyle(type)}
  }
  
  &:hover::after { 
    ${FontLinkHoverStyle}
  }
`;
};
const Body1Styles = props => {
  const variantLinkStyles = props.variant === Variant.LINK && FontLinkStyle("body1");
  return css`
    ${DefaultBodyStyles(props)};
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.02rem;
    
    ${variantLinkStyles};
  `;
};
styled.p`
  ${Body1Styles}
`;
const Body2Styles = props => {
  const variantLinkStyles = props.variant === Variant.LINK && FontLinkStyle("body2");
  return css`
    ${DefaultBodyStyles(props)};
    font-style: italic;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;

    ${variantLinkStyles};
  `;
};
styled.p`
  ${Body2Styles}
`;
const Body3Styles = props => {
  const variantLinkStyles = props.variant === Variant.LINK && FontLinkStyle("body3");
  return css`
    ${DefaultBodyStyles(props)};
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.5;
    letter-spacing: 0.02rem;

    ${variantLinkStyles};
  `;
};
styled.p`
  ${Body3Styles}
`;
const Body4Styles = props => {
  const variantLinkStyles = props.variant === Variant.LINK && FontLinkStyle("body4");
  return css`
    ${DefaultBodyStyles(props)};
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.0175rem;
    
    ${variantLinkStyles};
  `;
};
styled.p`
  ${Body4Styles};
`;
const Body5Styles = props => {
  const variantLinkStyles = props.variant === Variant.LINK && FontLinkStyle("body5");
  return css`
    ${DefaultBodyStyles(props)};
    font-size: 0.875rem;
    font-style: italic;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.0175rem;
    
    ${variantLinkStyles};
  `;
};
styled.p`
  ${Body5Styles}
`;
const Body6Styles = props => {
  const variantLinkStyles = props.variant === Variant.LINK && FontLinkStyle("body6");
  return css`
    ${DefaultBodyStyles(props)};
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.5;
    letter-spacing: 0.0175rem;
    
    ${variantLinkStyles};
  `;
};
styled.p`
  ${Body6Styles};
`;
const Button1Styles = () => {
  return css`
    font-family: var(--font-helvetica);
    font-size: 1rem;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: 0.02rem;
    text-transform: initial;
    text-align: center;
    margin: 0;
    position: relative;
  `;
};
const StyledButtonText1 = styled.span`
  ${Button1Styles}
`;
const ButtonText1 = _a => {
  var {
      children
    } = _a,
    props = __rest(_a, ["children"]);
  return /*#__PURE__*/React.createElement(StyledButtonText1, Object.assign({}, props, {
    "data-component": "button1"
  }), children);
};
const Button2Styles = () => {
  return css`
    font-family: var(--font-helvetica);
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.2;
    letter-spacing: 0.0175rem;
    text-transform: initial;
    text-align: center;
    margin: 0;
    position: relative;
  `;
};
styled.span`
  ${Button2Styles}
`;
const LinkStyles = props => {
  var _a, _b;
  const fontSize = props.variant === Variant.SMALL ? `0.875rem` : `1rem`;
  const letterSpacing = props.variant === Variant.SMALL ? "0.0175rem" : "0.02rem";
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.INHERIT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  return css`
    font-family: var(--font-helvetica);
    font-size: ${fontSize};
    font-weight: 700;
    line-height: 1.5;
    letter-spacing: ${letterSpacing};
    text-transform: initial;
    text-align: ${textAlign};
    color: ${color};
    word-break: break-word;
    position: relative;
    text-decoration: none;
    width: fit-content;
    cursor: pointer;

    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 1px;
      bottom: 2px;
      left: 0;
      background-color: currentColor;
      visibility: visible;
      transition: all 0.3s ease-in-out;
    }

    &:hover {
      text-decoration: none;
    }

    &:hover::before {
      visibility: hidden;
      width: 0;
    }
  `;
};
styled.a`
  ${LinkStyles};
`;
const CaptionStyles = props => {
  var _a, _b;
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.LEFT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  return css`
    font-family: var(--font-helvetica);
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.015rem;
    text-align: ${textAlign};
    color: ${color};
    text-transform: initial;
  `;
};
styled.p`
  ${CaptionStyles}
`;
const OverlineStyles = props => {
  var _a, _b;
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.LEFT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  return css`
    font-family: var(--font-helvetica);
    font-size: 0.75rem;
    font-weight: 400;
    line-height: 1.3;
    letter-spacing: 0.03rem;
    text-align: ${textAlign};
    color: ${color};
    text-transform: uppercase;
    margin-bottom: 0;
  `;
};
styled.p`
  ${OverlineStyles}
`;
const Subtitle1Styles = props => {
  var _a, _b;
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.LEFT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  return css`
    font-family: var(--font-helvetica);
    font-size: 1.125rem;
    font-weight: 400;
    line-height: 1.5;
    letter-spacing: 0.0225rem;
    text-align: ${textAlign};
    color: ${color};
    text-transform: initial;
  `;
};
styled.p`
  ${Subtitle1Styles}
`;
const Subtitle2Styles = props => {
  var _a, _b;
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.LEFT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  return css`
    font-family: var(--font-helvetica);
    font-size: 1.125rem;
    font-weight: 400;
    font-style: italic;
    line-height: 1.5;
    letter-spacing: 0.0225rem;
    text-align: ${textAlign};
    color: ${color};
    text-transform: initial;
  `;
};
styled.p`
  ${Subtitle2Styles}
`;
const Subtitle3Styles = props => {
  var _a, _b;
  const textAlign = (_a = props.alignment) !== null && _a !== void 0 ? _a : TextAlignment.LEFT;
  const color = (_b = props.textColor) !== null && _b !== void 0 ? _b : "var(--colour-black)";
  return css`
    font-family: var(--font-helvetica);
    font-size: 1.125rem;
    font-weight: 700;
    line-height: 1.5;
    letter-spacing: 0.0225rem;
    text-align: ${textAlign};
    color: ${color};
    text-transform: initial;
    margin-bottom: 0;
  `;
};
styled.p`
  ${Subtitle3Styles}
`;
styled.blockquote`
  position: relative;
  font-family: ${props => props.market && ["urban", "veilance"].includes(props.market.toLowerCase()) ? '"Suisse Intl Regular", arial, sans-serif' : 'var(--font-helvetica)'};
  color: ${props => props.textColor};
  font-size: 1rem;
  font-weight: 400;
  font-style: italic;
  line-height: 1.2rem;
  padding-left: 2.5rem;
  max-width: 500px;
`;
styled.p`
  max-width: none;
`;
styled.ul`
max-width: none;
`;
styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;
styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
`;
const Cube = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 0 1rem;
  font-size: 1rem;

  &:after {
    content: attr(title);
    display: block;
    position: absolute;
    bottom: -3rem;
    left: 50%;
    transform: translateX(-50%);
  }
`;
styled(Cube)`
  width: var(--space-xs);
  height: var(--space-xs);
  background-color: #EBCC83;
`;
styled(Cube)`
  width: var(--space-s);
  height: var(--space-s);
  background-color: #A0E6EB;
`;
styled(Cube)`
  width: var(--space-m);
  height: var(--space-m);
  background-color: #C8EBA0;
`;
styled(Cube)`
  width: var(--space-l);
  height: var(--space-l);
  background-color: #A0AFEB;
`;
styled(Cube)`
  width: var(--space-xl);
  height: var(--space-xl);
  background-color: #DBABE9;
`;
styled(Cube)`
  width: var(--space-xxl);
  height: var(--space-xxl);
  background-color: #EB9595;
`;
const Square = styled.div`
  width: 1rem;
  height: 1rem;
  display: inline-block;
  margin-right: 5px;  
`;
styled(Square)`
  background-color: #EBCC83;
`;
styled(Square)`
  background-color: #A0E6EB;
`;
styled(Square)`
  background-color: #C8EBA0;
`;
styled(Square)`
  background-color: #A0AFEB;
`;
styled(Square)`
  background-color: #DBABE9;
`;
styled(Square)`
  background-color: #EB9595;
`;
createGlobalStyle`

// This is the site-wide root CSS where we define our global variables
:root {
  --font-elan: "elan-itc-pro", sans-serif;
  --font-helvetica: "helvetica-now-display", sans-serif;
  --font-urw:  "helvetica-now-display", sans-serif;
  --focus-visible: 0.2rem solid #5b9dd9;

  /**
   * Colours
   */
  --colour-black: #1A1A1A;
  --colour-grey-dark: #333333;
  --colour-grey-medium: #666666;
  --colour-grey-inactive: #b2b2b2;
  --colour-grey-pinline: #cccccc;
  --colour-grey-background: #e9e9e9;
  --colour-grey-item-background: #fafafa;
  --colour-black-gradient: #646464;
  --colour-white: #ffffff;
    
  /*
   * Feedback Colours
   */
  --colour-red-3: #990000;
  --colour-red-2: #c86464;
  --colour-red-1: #fbebeb;

  --colour-yellow-3: #785e1c;
  --colour-yellow-2: #ab934f;
  --colour-yellow-1: #f8f2d5;

  --colour-blue-3: #31668f;
  --colour-blue-2: #5b9dd9;
  --colour-blue-1: #e3edf2;

  --colour-green-3: #227733;
  --colour-green-2: #5aab6a;
  --colour-green-1: #dff0d8;
  
  --gradient-active: linear-gradient(180deg, var(--colour-black) 9.38%, var(--colour-black-gradient)  73.96%), var(--colour-white);
  --gradient-hover: linear-gradient(180deg, var(--colour-black-gradient) 5.21%, var(--colour-black) 87.5%), var(--colour-white);
  
  /* Why Renaming Base Color Variables? */
  --colour-copy: var(--colour-black);
  --black: var(--colour-black);
  --dark-grey: var(--colour-grey-dark);
  --medium-grey: var(--colour-grey-medium);
  --inactive-state-grey: var(--colour-grey-inactive);
  --pinline-grey: var(--colour-grey-pinline);
  --background-grey: var(--colour-grey-background);
  --background-gradient: var(--colour-black-gradient);
  --white: var(--colour-white);

  /* WHY Renaming Color Variables in Core-UI? */
  --warning-red: var(--colour-red-3);
  --medium-red: var(--colour-red-2);
  --background-red: var(--colour-red-1);

  /* WHY Renaming Color Variables in Core-UI? */
  --caution-yellow: var(--colour-yellow-3);
  --medium-yellow: var(--colour-yellow-2);
  --background-yellow: var(--colour-yellow-1);

  /* WHY Renaming Color Variables in Core-UI? */
  --info-blue: var(--colour-blue-3);
  --focus-blue: var(--colour-blue-2);
  --background-blue: var(--colour-blue-1);

  /* WHY Renaming Color Variables in Core-UI? */
  --success-green: var(--colour-green-3);
  --medium-green: var(--colour-green-2);
  --background-green: var(--colour-green-1);

  /**
   * Spacing Units (Deprecated)
   * These tie in directly with the coloured spaces depicted in design mocks
   * Responsiveness is built-in to the variable, so no component-level tweaks needed
   */
  --space-red: 6rem;
  --space-pink: 4rem;
  --space-purple: 2rem;
  --space-green: 2rem;
  --space-blue: 1rem;
  --space-orange: .5rem;

  @media(min-width: 1024px) {
    --space-purple: 3rem;
    --space-pink: 6rem;
    --space-red: 10rem;
  }

  /**
   * Spacing Units
   * These tie in directly with the spacing units defined in Figma
   * https://www.figma.com/file/xiTC7i82LbrfGrMQRqsxLY/Arc'teryx-Components?type=design&node-id=781-52&mode=design&t=LHI4MFqa1SCYqNKI-0
   */
  --desk-mobile05: 0.5rem;
  --desk-mobile1: 1rem;
  --desk-mobile2: 2rem;
  --desk3-mobile2: 2rem;
  --desk6-mobile4: 4rem;
  --desk10-mobile6: 6rem;

  @media(min-width: 992px) {
    --desk3-mobile2: 3rem;
    --desk6-mobile4: 6rem;
    --desk10-mobile6: 10rem;
  }

  // Spacing Units - Aliases
  --space-xs: var(--desk-mobile05);
  --space-s: var(--desk-mobile1);
  --space-m: var(--desk-mobile2);
  --space-l: var(--desk3-mobile2);
  --space-xl: var(--desk6-mobile4);
  --space-xxl: var(--desk10-mobile6);

  /**
   * CatIntro Banners
   */
   --banner-height-xs: 10rem; /* 150px */
   --banner-height-sm: 12rem; /* 180px */
   --banner-height-md: 13.333rem; /* 200px */
   --banner-height-lg: 16.666rem; /* 250px */
   --banner-height-xl: 23.333rem; /* 350px */

   /**
    * Common breakpoints
    */
   --breakpoint-sm: 576px;
   --breakpoint-md: 768px;
   --breakpoint-lg: 992px;
   --breakpoint-xl: 1200px;
   /**
    * ProductTiles
    */
   --product-tile-2-col: 50%;
   --product-tile-3-col: 33.33%;
   --product-tile-4-col: 25%;
}

html {
  height: 100%;
  height: -webkit-fill-available;
  scroll-behavior: smooth;

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }
}

ul[class],
ol[class] {
  padding: 0;
}

body,
ul[class],
ol[class],
li,
figure,
figcaption,
blockquote,
dl,
dd {
  margin: 0;
}
body {
  min-height: 100vh;
  min-height: -webkit-fill-available;
  text-rendering: optimizeSpeed;
  font-size: 1rem;
  line-height: 1.5;
  font-family: var(--font-helvetica);
  color: var(--colour-black);
}

ol, ul {
  list-style-position: outside;
  margin: 1rem 0 0 0;
  padding: 0 0 0 2rem;
}
ul {
  list-style-type: disc;
}
li {
  line-height: 1.5rem;
  padding-bottom: 0.5rem;
}

ul[class],
ol[class] {
  list-style: none;
}

/* helper class to hide scrollbars */
.hide--scrollbar {
  /* Chrome, Safari and Opera */
  ::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;  /* Firefox */
}

a:not([class]) {
  text-decoration: underline;
  text-decoration-skip-ink: auto;
}

a:focus, button:focus {
  outline: none;
}

a:focus-visible, button:focus-visible {
  outline: var(--focus-visible);
}

a:-moz-focus-visible, button:-moz-focus-visible,
:-moz-focusring {
  outline: var(--focus-visible);
}

/**
  *  Heading tags; h1, h2, h3, h4
  *  Ideally all Heading tags will use the <H1>, <H2>, <H3>, and <H4> provided by @arcteryx/components-typography
  *  but this will help catch any tags that might not be styled-components
  */
h1, h2, h3, h4 {
  font-weight: 700;
  line-height: 1.5rem;
  margin-top: 0;
}

h1, h4 {
    font-family: var(--font-elan);
}
h2, h3, h5, h6 {
    font-family: var(--font-helvetica);
}

h1 {
  margin-bottom: 1rem;
  font-size: 1.5rem;
}
h2 {
  margin-bottom: 1rem;
  font-size: 1.25rem;
}
h3 {
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}
h4 {
  margin-bottom: 0.5rem;
  font-size: 1rem;
}

p {
  ${Body1Styles({
  alignment: TextAlignment.INHERIT
})};

  strong, b {
    ${Body3Styles({
  alignment: TextAlignment.INHERIT
})}
  }

  em, i {
    ${Body2Styles({
  alignment: TextAlignment.INHERIT
})}
  }

  &:last-of-type {
    margin-bottom: 0;
  }
}

strong, b {
  ${Body3Styles({
  alignment: TextAlignment.INHERIT
})}
}

em, i {
  ${Body2Styles({
  alignment: TextAlignment.INHERIT
})}
}

img {
  max-width: 100%;
  display: block;
}

.lazyload,
.lazyloading {
  opacity: 0;
}

.lazyloaded {
  opacity: 1;
  transition: opacity 200ms;
}

/* Legacy class for header nav hover overlay */

.overlay-dark--full {
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 1;
  z-index: 250;
}

/**
 * a11y
 * For folks who's browser requests reduced motion
 */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}

/* Helvetica Now Display */
@font-face {
  /* Light */
  font-family: "helvetica-now-display";
  font-style: normal;
  font-stretch: normal;
  font-display: swap;
  font-weight: 300;
  src: url("https://images.arcteryx.com/fonts/HelveticaNowDisplayLight_normal_normal.woff2") format("woff2"),
  url("https://images.arcteryx.com/fonts/HelveticaNowDisplayLight_normal_normal.woff") format("woff");
}

@font-face {
  /* Italic */
  font-family: "helvetica-now-display";
  font-style: italic;
  font-stretch: normal;
  font-display: swap;
  font-weight: 400;
  src: url("https://images.arcteryx.com/fonts/HelveticaNowDisplayItalic_italic_normal.woff2") format("woff2"),
  url("https://images.arcteryx.com/fonts/HelveticaNowDisplayItalic_italic_normal.woff") format("woff");
}

@font-face {
  /* Regular */
  font-family: "helvetica-now-display";
  font-style: normal;
  font-stretch: normal;
  font-display: swap;
  font-weight: 400;
  src: url("https://images.arcteryx.com/fonts/HelveticaNowDisplayRegular_normal_normal.woff2") format("woff2"),
  url("https://images.arcteryx.com/fonts/HelveticaNowDisplayRegular_normal_normal.woff") format("woff");
}

@font-face {
  /* Bold */
  font-family: "helvetica-now-display";
  font-style: normal;
  font-stretch: normal;
  font-display: swap;
  font-weight: 700;
  src: url("https://images.arcteryx.com/fonts/HelveticaNowDisplayBold_normal_normal.woff2") format("woff2"),
  url("https://images.arcteryx.com/fonts/HelveticaNowDisplayBold_normal_normal.woff") format("woff");
}

/* Elan ITC */
@font-face {
    font-family: "elan-itc-pro";
    font-style: normal;
    font-stretch: normal;
    font-display: swap;
    font-weight: 400;
    src:
      url('https://images.arcteryx.com/fonts/ElanITCPro-Book-Web.woff2') format('woff2'),
      url('https://images.arcteryx.com/fonts/ElanITCPro-Book-Web.woff') format('woff');
}

/*
 * The Typekit service used to deliver this font or fonts for use on websites
 * is provided by Adobe and is subject to these Terms of Use
 * http://www.adobe.com/products/eulas/tou_typekit. For font license
 * information, see the list below.
 *
 * urw-din:
 *   - http://typekit.com/eulas/00000000000000007735a839
 *   - http://typekit.com/eulas/00000000000000007735a83d
 *   - http://typekit.com/eulas/00000000000000007735a840
 *   - http://typekit.com/eulas/00000000000000007735a843
 *   - http://typekit.com/eulas/00000000000000007735a846
 *   - http://typekit.com/eulas/00000000000000007735a849
 *   - http://typekit.com/eulas/00000000000000007735a84b
 *   - http://typekit.com/eulas/00000000000000007735a84f
 *   - http://typekit.com/eulas/00000000000000007735a851
 *   - http://typekit.com/eulas/00000000000000007735a855
 * urw-din-condensed:
 *   - http://typekit.com/eulas/00000000000000007735a83b
 *   - http://typekit.com/eulas/00000000000000007735a83e
 *   - http://typekit.com/eulas/00000000000000007735a841
 *   - http://typekit.com/eulas/00000000000000007735a844
 *   - http://typekit.com/eulas/00000000000000007735a847
 *   - http://typekit.com/eulas/00000000000000007735a84a
 *   - http://typekit.com/eulas/00000000000000007735a84d
 *   - http://typekit.com/eulas/00000000000000007735a850
 *   - http://typekit.com/eulas/00000000000000007735a853
 *   - http://typekit.com/eulas/00000000000000007735a856
 * urw-din-semi-condensed:
 *   - http://typekit.com/eulas/00000000000000007735a83c
 *   - http://typekit.com/eulas/00000000000000007735a83f
 *   - http://typekit.com/eulas/00000000000000007735a842
 *   - http://typekit.com/eulas/00000000000000007735a845
 *   - http://typekit.com/eulas/00000000000000007735a848
 *   - http://typekit.com/eulas/00000000000000007735a84c
 *   - http://typekit.com/eulas/00000000000000007735a84e
 *   - http://typekit.com/eulas/00000000000000007735a852
 *   - http://typekit.com/eulas/00000000000000007735a854
 *   - http://typekit.com/eulas/00000000000000007735a857
 *
 * © 2009-2023 Adobe Systems Incorporated. All Rights Reserved.
 */
/*{"last_published":"2023-09-27 18:05:37 UTC"}*/

@import url("https://p.typekit.net/p.css?s=1&k=amb0fbb&ht=tk&f=36601.36602.36603.36604.36605.36606.36607.36608.36609.36610.36617.36618.36619.36620.36621.36622.36623.36624.36625.36626.36633.36634.36635.36636.36637.36638.36639.36640.36641.36642&a=131936418&app=typekit&e=css");

@font-face {
font-family:"urw-din";
src:url("https://use.typekit.net/af/1f0265/00000000000000007735a839/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff2"),url("https://use.typekit.net/af/1f0265/00000000000000007735a839/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff"),url("https://use.typekit.net/af/1f0265/00000000000000007735a839/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:400;font-stretch:normal;
}

@font-face {
font-family:"urw-din";
src:url("https://use.typekit.net/af/f1d51b/00000000000000007735a83d/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/f1d51b/00000000000000007735a83d/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/f1d51b/00000000000000007735a83d/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:400;font-stretch:normal;
}

@font-face {
font-family:"urw-din";
src:url("https://use.typekit.net/af/5f44f1/00000000000000007735a840/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff2"),url("https://use.typekit.net/af/5f44f1/00000000000000007735a840/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff"),url("https://use.typekit.net/af/5f44f1/00000000000000007735a840/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"urw-din";
src:url("https://use.typekit.net/af/d96df7/00000000000000007735a843/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff2"),url("https://use.typekit.net/af/d96df7/00000000000000007735a843/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff"),url("https://use.typekit.net/af/d96df7/00000000000000007735a843/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"urw-din";
src:url("https://use.typekit.net/af/caf48f/00000000000000007735a846/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3") format("woff2"),url("https://use.typekit.net/af/caf48f/00000000000000007735a846/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3") format("woff"),url("https://use.typekit.net/af/caf48f/00000000000000007735a846/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:600;font-stretch:normal;
}

@font-face {
font-family:"urw-din";
src:url("https://use.typekit.net/af/b8eeae/00000000000000007735a849/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("woff2"),url("https://use.typekit.net/af/b8eeae/00000000000000007735a849/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("woff"),url("https://use.typekit.net/af/b8eeae/00000000000000007735a849/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:600;font-stretch:normal;
}

@font-face {
font-family:"urw-din";
src:url("https://use.typekit.net/af/1c5092/00000000000000007735a84b/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),url("https://use.typekit.net/af/1c5092/00000000000000007735a84b/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),url("https://use.typekit.net/af/1c5092/00000000000000007735a84b/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"urw-din";
src:url("https://use.typekit.net/af/cd97e9/00000000000000007735a84f/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/cd97e9/00000000000000007735a84f/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/cd97e9/00000000000000007735a84f/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"urw-din";
src:url("https://use.typekit.net/af/fe2f02/00000000000000007735a851/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff2"),url("https://use.typekit.net/af/fe2f02/00000000000000007735a851/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff"),url("https://use.typekit.net/af/fe2f02/00000000000000007735a851/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"urw-din";
src:url("https://use.typekit.net/af/0fba77/00000000000000007735a855/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff2"),url("https://use.typekit.net/af/0fba77/00000000000000007735a855/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff"),url("https://use.typekit.net/af/0fba77/00000000000000007735a855/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"urw-din-condensed";
src:url("https://use.typekit.net/af/b27e1e/00000000000000007735a83b/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff2"),url("https://use.typekit.net/af/b27e1e/00000000000000007735a83b/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff"),url("https://use.typekit.net/af/b27e1e/00000000000000007735a83b/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:400;font-stretch:normal;
}

@font-face {
font-family:"urw-din-condensed";
src:url("https://use.typekit.net/af/ba5c17/00000000000000007735a83e/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/ba5c17/00000000000000007735a83e/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/ba5c17/00000000000000007735a83e/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:400;font-stretch:normal;
}

@font-face {
font-family:"urw-din-condensed";
src:url("https://use.typekit.net/af/06eb22/00000000000000007735a841/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff2"),url("https://use.typekit.net/af/06eb22/00000000000000007735a841/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff"),url("https://use.typekit.net/af/06eb22/00000000000000007735a841/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"urw-din-condensed";
src:url("https://use.typekit.net/af/413a03/00000000000000007735a844/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff2"),url("https://use.typekit.net/af/413a03/00000000000000007735a844/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff"),url("https://use.typekit.net/af/413a03/00000000000000007735a844/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"urw-din-condensed";
src:url("https://use.typekit.net/af/c2cf88/00000000000000007735a847/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("woff2"),url("https://use.typekit.net/af/c2cf88/00000000000000007735a847/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("woff"),url("https://use.typekit.net/af/c2cf88/00000000000000007735a847/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:600;font-stretch:normal;
}

@font-face {
font-family:"urw-din-condensed";
src:url("https://use.typekit.net/af/b1d7bd/00000000000000007735a84a/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3") format("woff2"),url("https://use.typekit.net/af/b1d7bd/00000000000000007735a84a/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3") format("woff"),url("https://use.typekit.net/af/b1d7bd/00000000000000007735a84a/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:600;font-stretch:normal;
}

@font-face {
font-family:"urw-din-condensed";
src:url("https://use.typekit.net/af/be96d8/00000000000000007735a84d/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/be96d8/00000000000000007735a84d/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/be96d8/00000000000000007735a84d/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"urw-din-condensed";
src:url("https://use.typekit.net/af/3f20e7/00000000000000007735a850/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),url("https://use.typekit.net/af/3f20e7/00000000000000007735a850/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),url("https://use.typekit.net/af/3f20e7/00000000000000007735a850/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"urw-din-condensed";
src:url("https://use.typekit.net/af/5002a8/00000000000000007735a853/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff2"),url("https://use.typekit.net/af/5002a8/00000000000000007735a853/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff"),url("https://use.typekit.net/af/5002a8/00000000000000007735a853/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"urw-din-condensed";
src:url("https://use.typekit.net/af/c85988/00000000000000007735a856/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff2"),url("https://use.typekit.net/af/c85988/00000000000000007735a856/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff"),url("https://use.typekit.net/af/c85988/00000000000000007735a856/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"urw-din-semi-condensed";
src:url("https://use.typekit.net/af/68a396/00000000000000007735a83c/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff2"),url("https://use.typekit.net/af/68a396/00000000000000007735a83c/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("woff"),url("https://use.typekit.net/af/68a396/00000000000000007735a83c/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:400;font-stretch:normal;
}

@font-face {
font-family:"urw-din-semi-condensed";
src:url("https://use.typekit.net/af/960873/00000000000000007735a83f/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff2"),url("https://use.typekit.net/af/960873/00000000000000007735a83f/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("woff"),url("https://use.typekit.net/af/960873/00000000000000007735a83f/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i4&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:400;font-stretch:normal;
}

@font-face {
font-family:"urw-din-semi-condensed";
src:url("https://use.typekit.net/af/40dae5/00000000000000007735a842/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff2"),url("https://use.typekit.net/af/40dae5/00000000000000007735a842/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("woff"),url("https://use.typekit.net/af/40dae5/00000000000000007735a842/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i5&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"urw-din-semi-condensed";
src:url("https://use.typekit.net/af/5788bc/00000000000000007735a845/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff2"),url("https://use.typekit.net/af/5788bc/00000000000000007735a845/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("woff"),url("https://use.typekit.net/af/5788bc/00000000000000007735a845/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n5&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:500;font-stretch:normal;
}

@font-face {
font-family:"urw-din-semi-condensed";
src:url("https://use.typekit.net/af/96cf20/00000000000000007735a848/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3") format("woff2"),url("https://use.typekit.net/af/96cf20/00000000000000007735a848/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3") format("woff"),url("https://use.typekit.net/af/96cf20/00000000000000007735a848/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i6&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:600;font-stretch:normal;
}

@font-face {
font-family:"urw-din-semi-condensed";
src:url("https://use.typekit.net/af/bd0e8a/00000000000000007735a84c/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("woff2"),url("https://use.typekit.net/af/bd0e8a/00000000000000007735a84c/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("woff"),url("https://use.typekit.net/af/bd0e8a/00000000000000007735a84c/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n6&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:600;font-stretch:normal;
}

@font-face {
font-family:"urw-din-semi-condensed";
src:url("https://use.typekit.net/af/f61b58/00000000000000007735a84e/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff2"),url("https://use.typekit.net/af/f61b58/00000000000000007735a84e/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("woff"),url("https://use.typekit.net/af/f61b58/00000000000000007735a84e/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"urw-din-semi-condensed";
src:url("https://use.typekit.net/af/349829/00000000000000007735a852/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff2"),url("https://use.typekit.net/af/349829/00000000000000007735a852/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("woff"),url("https://use.typekit.net/af/349829/00000000000000007735a852/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i7&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:700;font-stretch:normal;
}

@font-face {
font-family:"urw-din-semi-condensed";
src:url("https://use.typekit.net/af/8def5a/00000000000000007735a854/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff2"),url("https://use.typekit.net/af/8def5a/00000000000000007735a854/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("woff"),url("https://use.typekit.net/af/8def5a/00000000000000007735a854/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n9&v=3") format("opentype");
font-display:auto;font-style:normal;font-weight:900;font-stretch:normal;
}

@font-face {
font-family:"urw-din-semi-condensed";
src:url("https://use.typekit.net/af/d4ff8c/00000000000000007735a857/30/l?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff2"),url("https://use.typekit.net/af/d4ff8c/00000000000000007735a857/30/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("woff"),url("https://use.typekit.net/af/d4ff8c/00000000000000007735a857/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=i9&v=3") format("opentype");
font-display:auto;font-style:italic;font-weight:900;font-stretch:normal;
}

.tk-urw-din { font-family: "urw-din",sans-serif; }
.tk-urw-din-condensed { font-family: "urw-din-condensed",sans-serif; }
.tk-urw-din-semi-condensed { font-family: "urw-din-semi-condensed",sans-serif; }
`;
const _excluded$1 = ["market", "context", "type", "size", "IconButtonLeft", "IconButtonRight", "disabled", "isWaiting", "onClick", "className", "id", "style", "children", "href", "width"];
const ButtonWrapper$1 = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${props => widthValue(props)};
  max-width: ${props => props.context === ADDTOCART && "400px" || props.context === SECURE && "100%"};
  height: 3rem;
  padding: 0 1rem 0 1rem;
  margin: 0;
  color: ${props => [INVERTED, SUBTLE, FINDINSTORE, SECONDARY].includes(props.context) ? "var(--colour-black)" : "var(--colour-white)"};
  text-decoration: none;
  border-radius: 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: ${props => [SUBTLE, FINDINSTORE].includes(props.context) ? "1px solid var(--colour-black)" : "1px solid transparent"};
  text-transform: ${props => props.context === STANDARD || !props.href ? "uppercase" : "none"};
  word-break: keep-all;
  cursor: pointer;
  background-color: ${props => [INVERTED, SUBTLE, FINDINSTORE, SECONDARY].includes(props.context) ? "var(--colour-white)" : "var(--colour-black)"};

  &:hover,
  &:active {
    border: ${props => props.context === SECONDARY ? "1px solid var(--colour-black)" : "1px solid transparent"};
    background-image: linear-gradient(var(--colour-black), var(--background-gradient));
    transition: background-color 400ms ease-in;
    text-decoration: none;
    color: ${props => props.context === SECONDARY ? "var(--colour-black)" : "var(--colour-white)"};
  }

  &.waiting,
  &.is-waiting {
    color: ${props => [SUBTLE, FINDINSTORE, SECONDARY].includes(props.context) ? "var(--colour-white)" : "var(--colour-black)"};
    pointer-events: none;

    &::before,
    &::after {
      display: none;
    }
  }

  ${props => props.disabled && css`
      &:disabled,
      &.disabled {
        color: ${() => props.context === SECONDARY ? "var(--colour-grey-inactive)" : "var(--colour-white)"};
        cursor: not-allowed;
        background-color: ${() => props.context === SECONDARY ? "var(--colour-grey-background)" : "var(--colour-grey-inactive)"};
        border: none;
        &:hover {
          /* border: 1px solid transparent; */
          background-image: none;
        }
      }
    `};

  ${props => props.context === SECURE && css`
      &::after {
        content: url(//images.arcteryx.com/foundation-ui/svgs/Secure_Icon_White.svg);
        width: 10px;
        height: 10px;
        margin-left: 10px;
        display: inline-block;
      }
    `};

  /* Inverted, Secondary-cta buttons */
  &.button--Secondary-cta {
    border: ${props => Boolean(props.href) ? "none" : "1px solid transparent"};
    text-decoration-line: ${props => Boolean(props.href) ? "underline" : "none"};
    &:hover,
    &:active,
    &:focus {
      background: var(--colour-white);
      color: var(--colour-black);
      border: ${props => Boolean(props.href) ? "none" : "1px solid var(--colour-black)"};
      font-weight: ${props => Boolean(props.href) ? "600" : "400"};
      cursor: pointer;
      text-decoration-line: ${props => Boolean(props.href) ? "underline" : "none"};
    }
    &.disabled {
      border: none;
      color: var(--colour-grey-inactive);
      cursor: not-allowed;
      background-color: ${props => Boolean(props.href) ? "transparent" : "var(--colour-grey-background)"};
      font-weight: 400;
      text-decoration-line: ${props => Boolean(props.href) ? "underline" : "none"};
    }
  }
  ${props => props.context === FINDINSTORE && css`
      display: flex;
      align-items: center;
      justify-content: center;
      width: 400px;
      max-width: 100%;
      line-height: 1rem;
      text-transform: none;
      &::before {
        content: url(//images.arcteryx.com/foundation-ui/svgs/Pin.svg);
        width: 16px;
        height: 16px;
        margin-right: 5px;
        display: inline-block;
      }
      &:hover {
        color: var(--colour-black);
        border: 1px solid var(--colour-black);
        background-image: none;
        background-color: var(--colour-white);
      }
    `};

  ${props => props.context === EMAIL && css`
      display: inline-flex;
      justify-content: center;
      align-items: center;
      &::before {
        content: url(//images.arcteryx.com/foundation-ui/svgs/Email_White.svg);
        width: 22px;
        margin-right: 5px;
        display: inline-block;
      }
    `};

  ${props => props.context === ADDTOCART && css`
      display: inline-flex;
      justify-content: center;
      align-items: center;
      &::before {
        content: url(//images.arcteryx.com/foundation-ui/svgs/Cart_Icon_White.svg);
        width: 22px;
        margin-right: 5px;
        display: inline-block;
      }
    `};
`;
const StyledIconWrapper = styled.span`
  margin-left: 5px;
  margin-right: 5px;
`;
const IconButton = _ref => {
  let {
    icon
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledIconWrapper, null, icon);
};
const Button = _ref2 => {
  let {
      market,
      context,
      type,
      size,
      IconButtonLeft,
      IconButtonRight,
      disabled,
      isWaiting,
      onClick,
      className,
      id,
      style,
      children,
      href = "",
      width
    } = _ref2,
    otherProps = _objectWithoutProperties(_ref2, _excluded$1);
  const baseClass = "button";
  const rootClass = cx(baseClass, className, {
    [`${baseClass}--${market}`]: market,
    [`${baseClass}--${context}`]: context,
    [`${baseClass}--${size}`]: size,
    disabled,
    waiting: isWaiting,
    "is-waiting": isWaiting
  });
  const isAnchorElement = Boolean(href);
  const as = isAnchorElement ? "a" : "button";
  const hasIconButtonLeft = Boolean(IconButtonLeft);
  const hasIconButtonRight = Boolean(IconButtonRight);
  return /*#__PURE__*/React.createElement(ButtonWrapper$1, _extends({
    as: as,
    id: id,
    href: isAnchorElement ? href : undefined,
    className: rootClass,
    type: isAnchorElement ? undefined : type,
    style: style,
    onClick: onClick,
    size: size,
    market: market,
    context: context,
    disabled: disabled,
    width: width
  }, otherProps), isWaiting && /*#__PURE__*/React.createElement(LoadingIcon, {
    "data-testid": "loading-icon"
  }), !isWaiting && hasIconButtonLeft && /*#__PURE__*/React.createElement(IconButton, {
    icon: IconButtonLeft
  }), /*#__PURE__*/React.createElement(ButtonText1, null, children), !isWaiting && hasIconButtonRight && /*#__PURE__*/React.createElement(IconButton, {
    icon: IconButtonRight
  }));
};
Button.displayName = "Button";
Button.defaultProps = {
  context: "Standard",
  market: "Outdoor",
  type: "button",
  disabled: false,
  isWaiting: false,
  onClick: null,
  style: {}
};
Button.propTypes = {
  context: PropTypes.oneOf(["Standard", "Inverted", "Subtle", "Secondary-cta", "Secure-checkout", "Add-To-Cart", "Find-In-Store", "Email"]),
  type: PropTypes.string,
  market: PropTypes.oneOf(["Outdoor", "Leaf", "Veilance"]),
  id: PropTypes.string,
  size: PropTypes.oneOf(["xs", "sm", "md", "lg"]),
  disabled: PropTypes.bool,
  isWaiting: PropTypes.bool,
  onClick: PropTypes.func,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  IconButtonLeft: PropTypes.node,
  IconButtonRight: PropTypes.node
};

const adaptCMSSearchStaticLinks = data => {
  if (!Array.isArray(data)) {
    console.error("Expected an array but received", data);
    return [];
  }
  return data.map(_ref => {
    let {
      header,
      callToAction
    } = _ref;
    return {
      header,
      links: callToAction.map(_ref2 => {
        let {
          link,
          linkText
        } = _ref2;
        return {
          url: link,
          label: linkText
        };
      })
    };
  });
};

const SearchStaticLinksWrapper = styled.div`
  max-width: 95.333rem;
  margin: 0 auto;
  padding: 1rem 0;
  h4 {
    margin: 0 0.5rem;
    color: var(--colour-copy);
  }
  width: 98%;
  ${Breakpoint("sm")`
    width: 94%;
  `}
  ${Breakpoint("lg")`
    width: 88%;
  `}
`;
const ButtonWrapper = styled.div`
  padding: 0.5rem 0 1.5rem;
  .button {
    border: 1px solid var(--pinline-grey) !important;
    padding: 0.5rem;
    height: 30px;
    font-size: 1rem;
    color: var(--colour-grey-dark);
    text-transform: none;
    font-weight: inherit;
    margin: 0.5rem;
  }
`;
const StyledSubtitle3 = styled(Subtitle3)`
  margin-left: 0.5rem;
`;
const FinderButton = styled(Button)`
  background-color: var(--white);
  display: inline-flex;
  align-items: center;
  padding: 0px 8px 2px;
  gap: 12px;
  border: 1px solid var(--inactive-state-grey);
  cursor: pointer;

  span {
    ${Body1Styles$1}
  }
`;
const SectionWrapper = styled.div``;
const SearchStaticLinks = _ref => {
  let {
    cmsStaticSearchLinks
  } = _ref;
  const {
    market,
    country,
    language
  } = useContext(SiteContext);
  const [sections, setSections] = useState(null);
  const {
    suggestedSearch
  } = useContext(IndexContext);
  const handleClick = link => {
    if (link.url.startsWith("?search")) {
      var _searchParams$get;
      const searchParams = new URLSearchParams(link.url);
      const query = ((_searchParams$get = searchParams.get("search")) === null || _searchParams$get === void 0 ? void 0 : _searchParams$get.split("-").map(e => e.charAt(0).toUpperCase() + e.slice(1)).join(" ")) || link.label;
      const {
        setIsOpen,
        setQuery,
        refresh,
        setContext
      } = suggestedSearch;
      setIsOpen(false);
      setQuery(query);
      setContext({
        staticTerm: query
      });
      refresh();
    } else {
      const url = new URL(link.url);
      window.location.href = `${url.origin}/${country}/${language}${url.pathname}/${url.search}`;
    }
  };
  if (market === "leaf") {
    return null;
  }
  useEffect(() => {
    const adaptedData = adaptCMSSearchStaticLinks(cmsStaticSearchLinks);
    setSections(adaptedData);
  }, [cmsStaticSearchLinks]);
  return /*#__PURE__*/React.createElement(SearchStaticLinksWrapper, null, sections !== null && sections !== void 0 && sections.length ? sections === null || sections === void 0 ? void 0 : sections.map((_ref2, index) => {
    let {
      header,
      links
    } = _ref2;
    return /*#__PURE__*/React.createElement(SectionWrapper, {
      key: index
    }, /*#__PURE__*/React.createElement(StyledSubtitle3, null, header), /*#__PURE__*/React.createElement(ButtonWrapper, null, (links === null || links === void 0 ? void 0 : links.length) && (links === null || links === void 0 ? void 0 : links.map((link, i) => /*#__PURE__*/React.createElement(FinderButton, {
      context: "Secondary-cta",
      onClick: () => handleClick(link),
      key: i
    }, link.label)))));
  }) : "");
};
SearchStaticLinks.propTypes = {
  cmsStaticSearchLinks: PropTypes.array
};

const SearchBarContainer = styled.div``;
const SearchBarWrapper = styled.div`
  padding: 3rem 0.5rem 1rem;
  position: relative;
  z-index: 201;
  background-color: var(--white);
  ${Breakpoint("md")`
    padding: 3rem 0 1rem;
  `}
`;
const SearchBarInner = styled.div`
  max-width: 95.333rem;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  width: 98%;
  ${Breakpoint("sm")`
    width: 94%;
  `}
  ${Breakpoint("lg")`
    width: 88%;
  `}
`;
const SearchClose = styled.button`
  flex: 0 0 auto;
  font-size: 1.5rem;
  padding-left: 1rem;
  cursor: pointer;
  background: transparent;
  border-width: 0;
  color: var(--black);
`;
const SearchPanel = styled.div`
  max-width: 95.333rem;
  margin: auto;
  width: 98%;
  ${Breakpoint("sm")`
    width: 94%;
  `}
  ${Breakpoint("lg")`
    width: 88%;
  `}
  .aa-Panel {
    position: relative;
    top: auto !important;
    left: auto !important;
    right: auto !important;
    border: none;
    box-shadow: none;
    margin: 0;
    * {
      font-family: var(--font-helvetica);
    }
    .aa-GradientBottom {
      display: none;
    }
  }
  .aa-List {
    .aa-Item {
      padding-left: 9px;
      &[aria-selected="true"] {
        background-color: transparent;
      }
    }
  }
  .aa-ItemActions {
    display: none;
  }
  .aa-ItemLink {
    text-decoration: none;
  }
`;
const SearchPanelContainer = styled.div`
  height: 100vh;
  width: 100%;
`;
const CloseButton = _ref => {
  let {
    mountNode,
    location,
    history
  } = _ref;
  const onClose = () => {
    ReactDOM.unmountComponentAtNode(mountNode);
    location.search = "";
    history.push(location);
    document.dispatchEvent(new CustomEvent("search-closed"));
  };
  return /*#__PURE__*/React.createElement(SearchClose, {
    "data-testid": "arc-SearchClose",
    onClick: onClose
  }, "\u2715");
};
const SearchBar = withRouter(_ref2 => {
  let {
    mountNode,
    location,
    history,
    searchResults,
    cmsUrl,
    query,
    searchState,
    store,
    cmsStaticSearchLinks
  } = _ref2;
  const {
    results,
    isSearchStalled
  } = searchResults;
  const hasResults = results && results.nbHits !== 0;
  const {
    analyticsEvents,
    suggestedSearchContext
  } = useContext(IndexContext);
  const searchPanelRef = useRef(null);
  useEffect(() => {
    // Check if search is stalled and the user has made a query
    if (!isSearchStalled && query) {
      // If no results then resetSearch = true
      analyticsEvents.handleListingViewedEvent(results, !hasResults);
    }
  }, [searchState, isSearchStalled, hasResults, query, analyticsEvents, results]);
  const renderResults = () => {
    var _suggestedSearchConte, _suggestedSearchConte2;
    if (!query || !hasResults && suggestedSearchContext !== null && suggestedSearchContext !== void 0 && (_suggestedSearchConte = suggestedSearchContext.redirectUrlPlugin) !== null && _suggestedSearchConte !== void 0 && (_suggestedSearchConte2 = _suggestedSearchConte.data) !== null && _suggestedSearchConte2 !== void 0 && _suggestedSearchConte2.length) {
      return /*#__PURE__*/React.createElement(SearchStaticLinks, {
        cmsUrl: cmsUrl,
        cmsStaticSearchLinks: cmsStaticSearchLinks
      });
    }
    if (hasResults) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchResults, {
        query: query
      }), /*#__PURE__*/React.createElement(FilterBar, null));
    }
    return /*#__PURE__*/React.createElement(React.Fragment, null, store.getState().searching && /*#__PURE__*/React.createElement(SearchPanelContainer, null), /*#__PURE__*/React.createElement(SearchNoResults, {
      query: query,
      cmsUrl: cmsUrl
    }));
  };
  return /*#__PURE__*/React.createElement(SearchBarContainer, null, /*#__PURE__*/React.createElement(SearchBarWrapper, null, /*#__PURE__*/React.createElement(SearchBarInner, null, /*#__PURE__*/React.createElement(SearchBox, {
    autoFocus: true,
    delay: 200,
    searchPanelRef: searchPanelRef
  }), /*#__PURE__*/React.createElement(CloseButton, {
    mountNode: mountNode,
    location: location,
    history: history
  })), /*#__PURE__*/React.createElement(SearchPanel, {
    ref: searchPanelRef
  })), renderResults());
});
const ConnectedSearchBar = connectSearchBar(
/*#__PURE__*/
// prevent re-render when loading search results
React.memo(SearchBar, (_, nextProps) => nextProps.searchResults.searching === true));

const SearchProvider = _ref => {
  let {
    children,
    location,
    history,
    searchDebounceTime,
    stateFromHeader: {
      market: MARKET,
      language,
      country,
      environment
    },
    analyticsEvents,
    algoliaAppId,
    algoliaApiKey
  } = _ref;
  const market = MARKET.toLowerCase();
  const indexName = buildAlgoliaIndex({
    environment,
    market,
    language,
    country
  });
  const sort = adaptSort(indexName);
  const [searchState, setSearchState] = useState(urlToSearchState(location, sort.items));
  const [debouncedSetState, setDebouncedSetState] = useState(null);
  const [analyticsTags, setAnalyticsTags] = useState(null);
  const {
    isBrowser
  } = useSSR();
  const algoliaClient = algoliasearch(algoliaAppId, algoliaApiKey);
  const [searchClient, setSearchClient] = useState(null);
  const [suggestedSearch, setSuggestedSearch] = useState(null);
  const [suggestedSearchContext, setSuggestedSearchContext] = useState(null);
  const contextRef = useRef(suggestedSearchContext);
  const isRequestWithFacetFilters = requests => {
    return requests.some(_ref2 => {
      let {
        params
      } = _ref2;
      return params.facetFilters && params.facetFilters.length > 0;
    });
  };
  const isRequestSortBy = requests => {
    return requests.some(_ref3 => {
      let {
        indexName: requestedIndexName
      } = _ref3;
      return requestedIndexName.endsWith("_asc") || requestedIndexName.endsWith("_desc");
    });
  };

  // Init of Algolia Search
  useEffect(() => {
    const searchClientObject = {
      search(requests) {
        if (requests.every(_ref4 => {
          let {
            params
          } = _ref4;
          return !params.query;
        })) {
          return Promise.resolve({
            results: requests.map(() => ({
              hits: [],
              nbHits: 0,
              nbPages: 0,
              page: 0,
              processingTimeMS: 0,
              hitsPerPage: 0,
              exhaustiveNbHits: false,
              query: "",
              params: ""
            }))
          });
        }
        if (isRequestWithFacetFilters(requests) || isRequestSortBy(requests)) {
          return algoliaClient.search(requests);
        }
        const {
          results
        } = contextRef.current;
        return Promise.resolve({
          results
        });
      }
    };
    setSearchClient(searchClientObject);
  }, []);

  // Algolia Analytics
  useEffect(() => {
    const canTrackUser = window.OnetrustActiveGroups && window.OnetrustActiveGroups.includes(",C0002,") || true;
    setAnalyticsTags(isBrowser && buildTagsArray(window.navigator, canTrackUser ? document.cookie : null, window.location.pathname));
    aa("init", {
      appId: algoliaAppId,
      apiKey: algoliaApiKey,
      useCookie: canTrackUser
    });
  }, []);
  useEffect(() => {
    contextRef.current = suggestedSearchContext; // Update ref on every change
  }, [suggestedSearchContext]);
  const onSearchStateChange = updatedSearchState => {
    if (updatedSearchState.query === undefined) {
      return;
    }
    const {
      searchTermEntered,
      searchTermSuggested,
      staticTerm,
      termCount,
      terms
    } = suggestedSearchContext;
    clearTimeout(debouncedSetState);
    setDebouncedSetState(setTimeout(() => {
      history.push(searchStateToUrl(location, updatedSearchState, sort.items));
    }, searchDebounceTime));
    setSearchState(updatedSearchState);
    if (staticTerm) {
      analyticsEvents.handleSearchEvent({
        searchTermEntered: staticTerm,
        staticTerm
      });
    } else if (searchTermEntered && searchTermSuggested) {
      analyticsEvents.handleSearchEvent({
        searchTermEntered,
        searchTermSuggested,
        termCount,
        terms
      });
    } else {
      analyticsEvents.handleSearchEvent({
        searchTermEntered: updatedSearchState.query
      });
    }
  };
  const handleSetSuggestedSearch = useCallback(search => setSuggestedSearch(search), []);
  const handleSetSuggestedSearchContext = useCallback(context => setSuggestedSearchContext(context), []);
  return /*#__PURE__*/React.createElement(SiteContextProvider, {
    market: market,
    country: country,
    language: language
  }, /*#__PURE__*/React.createElement(IndexContextProvider, {
    index: indexName,
    analyticsEvents: analyticsEvents,
    algoliaClient: algoliaClient,
    environment: environment,
    suggestedSearch: suggestedSearch,
    setSuggestedSearch: handleSetSuggestedSearch,
    suggestedSearchContext: suggestedSearchContext,
    setSuggestedSearchContext: handleSetSuggestedSearchContext
  }, searchClient && /*#__PURE__*/React.createElement(InstantSearch, {
    indexName: indexName,
    searchClient: searchClient,
    searchState: searchState,
    onSearchStateChange: onSearchStateChange,
    createURL: createURL
  }, /*#__PURE__*/React.createElement(Configure, {
    clickAnalytics: true,
    analyticsTags: analyticsTags,
    hitsPerPage: 999
  }), children)));
};
var SearchProvider$1 = withRouter(SearchProvider);

const HitItem = styled.li`
  min-height: 400px; /* needs some height to avoid lazy loading too many on initial load */
  width: var(--product-tile-2-col);
  ${Breakpoint("lg")`
    width: var(--product-tile-3-col);
  `}
  ${Breakpoint("xl")`
    width: var(--product-tile-4-col);
  `}
  a {
    color: var(--colour-copy) !important;
  }
  span {
    line-height: inherit;
  }
  .qa--product-tile__thumbnail {
    box-sizing: border-box !important;
  }
  .product-badge {
    z-index: 1;
  }
  .product-tile__main-image {
    padding: 0; // override home page styling 
  }
`;
const Hit = _ref => {
  let {
    hit,
    insights,
    onLoad = false
  } = _ref;
  const ref = useRef();
  const [lazyProduct, setLazyProduct] = useState();
  const {
    analyticsEvents,
    index
  } = useContext(IndexContext);
  const {
    market
  } = useContext(SiteContext);
  const adaptedProductTile = adaptProductTile(hit);
  const product = useMemo(() => new ProductTile(adaptedProductTile), [hit]);
  const lazyloadProduct = async () => {
    setLazyProduct(product);
    if (onLoad) {
      setLazyProduct(new ProductTile(await onLoad(product)));
    }
  };
  const handleClick = () => {
    // Adobe Analytics
    // Params are the product object and the position of the product in the list - 1 because it's an array that starts at 0
    analyticsEvents.handleClickProductEvent(product, hit.__position - 1);
    // Algolia Analytics
    // Built in insights function automatically gets the correct data
    insights("clickedObjectIDsAfterSearch", {
      eventName: "Click item"
    });
    // Function helps persist data for conversions when user adds to cart and checkout
    persistConversionData({
      index,
      eventName: "Click item",
      queryID: hit.__queryID,
      objectIDs: [hit.objectID],
      positions: [hit.__position]
    });
  };
  useIntersectionObserver({
    target: ref,
    deps: [product.id],
    rootMargin: "400px",
    onIntersect: (_ref2, observerElement) => {
      let [{
        isIntersecting
      }] = _ref2;
      if (isIntersecting) {
        lazyloadProduct();
        if (observerElement && ref.current) {
          observerElement.unobserve(ref.current);
        }
      }
    }
  });
  return /*#__PURE__*/React.createElement(HitItem, {
    ref: ref,
    className: "ais-Hits-item"
  }, lazyProduct && /*#__PURE__*/React.createElement(ProductTile$1, {
    product: lazyProduct,
    imageLoadDebounceTime: 400,
    onMouseDown: handleClick,
    hideProductFlag: market !== "outdoor"
  }));
};
const SearchHit = connectHitInsights(aa)(Hit);

const _excluded = ["hits", "personalizedPriceProvider"];
const HitsContainer = styled.div`
  box-sizing: border-box;
  min-height: 29.333rem;
  max-width: 101rem;
  padding: 0 1rem 2rem;
  margin: 0 auto;
`;
const HitsList = styled.ul`
  min-width: 100%;
  min-height: 13.333rem;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  justify-content: space-around;
`;
const Hits = _ref => {
  let {
      hits,
      personalizedPriceProvider
    } = _ref,
    props = _objectWithoutProperties$1(_ref, _excluded);
  const queue = Promise.resolve(); // Create a promise chain, used in onLoadProduct()
  const onLoadProduct = useCallback(async product => {
    // Add personalized pricing graphql requests to the queue to be resolved
    await queue.then(async () => {
      if (personalizedPriceProvider) {
        await Product.$updateRealtimePrices([product], personalizedPriceProvider);
      }
    });
    return product;
  });
  if (!(hits !== null && hits !== void 0 && hits.length)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(HitsContainer, {
    className: "ais-Hits"
  }, /*#__PURE__*/React.createElement(HitsList, {
    className: "ais-Hits-list"
  }, hits === null || hits === void 0 ? void 0 : hits.map((hit, index) => /*#__PURE__*/React.createElement(SearchHit, _extends$1({
    key: hit === null || hit === void 0 ? void 0 : hit.objectID,
    hit: hit,
    onLoad: onLoadProduct
  }, props)))));
};
const SearchHits = connectHits(Hits);

const SearchContainerWrapper = styled.div`
  min-height: 75vh;
  overflow: hidden;
  color: var(--colour-copy);
  background-color: var(--white);
  -webkit-font-smoothing: initial;
  .search-bar-container {
    z-index: 100;
  }
`;

/**
 * SearchContainer
 * @param {string} mountNode document.createElement("div")
 * @param {object} stateFromHeader market, language, country, environment
 * @param {string} algoliaAppId get from Algolia dashboard
 * @param {string} algoliaApiKey get from Algolia dashboard
 * @param {integer} searchDebounceTime 400
 * @param {boolean} personalizedPriceProvider create provider from data-providers
 * @param {string} cmsUrl *.arcteryx.com
 * @param {object} analyticsEvents  handleListingViewedEvent(), handleSearchEvent(), handleClickProductEvent()
 * @param {string} deployEnv qa, stage, prod
 * @param {array} staticSearchLinks []
 * @returns Algolia React InstantSearch Container
 */
const SearchContainer = _ref => {
  let {
    mountNode,
    stateFromHeader,
    algoliaAppId,
    algoliaApiKey,
    searchDebounceTime,
    personalizedPriceProvider = false,
    cmsUrl,
    analyticsEvents,
    deployEnv,
    cmsStaticSearchLinks = []
  } = _ref;
  return /*#__PURE__*/React.createElement(SearchContainerWrapper, null, /*#__PURE__*/React.createElement(GlobalStyles, null), /*#__PURE__*/React.createElement(SearchProvider$1, {
    stateFromHeader: stateFromHeader,
    searchDebounceTime: searchDebounceTime,
    analyticsEvents: analyticsEvents,
    deployEnv: deployEnv,
    algoliaAppId: algoliaAppId,
    algoliaApiKey: algoliaApiKey
  }, /*#__PURE__*/React.createElement(ConnectedSearchBar, {
    mountNode: mountNode,
    cmsUrl: cmsUrl,
    cmsStaticSearchLinks: cmsStaticSearchLinks
  }), /*#__PURE__*/React.createElement(SearchHits, {
    personalizedPriceProvider: personalizedPriceProvider
  })));
};

var resources_DONOTEDIT = {
  "de": {
    "container-search": {
      "categories": "KATEGORIEN",
      "collection": "Kollektion",
      "colours": "Farbe",
      "FEMALE": "Damen",
      "gender": "Geschlecht",
      "Here are a few alternate destinations that might help.": "Hier finden Sie ein paar alternative Vorschläge, die Ihnen helfen könnten.",
      "In Stock": "Auf lager",
      "Items": "Artikel",
      "MALE": "Herren",
      "materials": "Materialien",
      "Name (A→Z)": "Name (A→Z)",
      "Name (Z→A)": "Name (Z→A)",
      "natural": "",
      "NEUTRAL": "Unisex",
      "Price (High→Low)": "Preis (absteigend)",
      "Price (Low→High)": "Preis (aufsteigend)",
      "properties": "Eigenschaften",
      "rating": "Beurteilung",
      "Refine": "Filter",
      "Search": "Suchen",
      "Search Result": "Es werden {{nbHits}} Suchergebnisse für „<0>{{query}}</0>” angezeigt",
      "showing results for": "Ergebnisse anzeigen für",
      "Sort": "Sortieren",
      "Top Rated": "Am besten bewertet",
      "We couldn't find any products that match your search.": "Wir können für Ihre Suche keine passenden Produkte finden.",
      "Weight (Low→High)": "Gewicht (aufsteigend)",
      "What's New": "Was ist neu"
    }
  },
  "en": {
    "container-search": {
      "categories": "Categories",
      "collection": "",
      "colours": "Colours",
      "FEMALE": "Women",
      "gender": "Gender",
      "Here are a few alternate destinations that might help.": "",
      "In Stock": "",
      "Items": "",
      "MALE": "Men",
      "materials": "Materials",
      "Name (A→Z)": "",
      "Name (Z→A)": "",
      "natural": "",
      "NEUTRAL": "Unisex",
      "Price (High→Low)": "",
      "Price (Low→High)": "",
      "properties": "",
      "rating": "Rating",
      "Refine": "",
      "Search": "",
      "Search Result": "Showing {{nbHits}} search results for '<0>{{query}}</0>'",
      "showing results for": "",
      "Sort": "",
      "Top Rated": "",
      "We couldn't find any products that match your search.": "",
      "Weight (Low→High)": "",
      "What's New": ""
    }
  },
  "es": {
    "container-search": {
      "categories": "CATEGORÍAS",
      "collection": "Colección",
      "colours": "Colores",
      "FEMALE": "Mujeres",
      "gender": "Sexo",
      "Here are a few alternate destinations that might help.": "Aquí le dejamos unos destinos alternativos que pueden servirle de ayuda.",
      "In Stock": "disponible",
      "Items": "Artículos",
      "MALE": "Hombres",
      "materials": "Materiales",
      "Name (A→Z)": "Nombre (A→Z)",
      "Name (Z→A)": "Nombre (Z→A)",
      "natural": "",
      "NEUTRAL": "Unisexo",
      "Price (High→Low)": "Precio (primero→más)",
      "Price (Low→High)": "Precio (más→primero)",
      "properties": "Propiedades",
      "rating": "Calificación",
      "Refine": "Restringir",
      "Search": "Buscar",
      "Search Result": "Mostrando {{nbHits}} resultados de búsqueda de '<0>{{query}}</0>'",
      "showing results for": "Mostrar resultados por",
      "Sort": "Ordenar",
      "Top Rated": "Mejor valorados",
      "We couldn't find any products that match your search.": "No se ha encontrado ningún producto que coincida con su búsqueda.",
      "Weight (Low→High)": "Peso (más→primero)",
      "What's New": "Novedades"
    }
  },
  "fr": {
    "container-search": {
      "categories": "CATÉGORIES",
      "collection": "Collection",
      "colours": "Couleurs",
      "FEMALE": "Femme",
      "gender": "Sexe",
      "Here are a few alternate destinations that might help.": "Voici quelques alternatives qui pourraient vous aider.",
      "In Stock": "en stock",
      "Items": "Articles",
      "MALE": "Homme",
      "materials": "Matières",
      "Name (A→Z)": "Nom (A→Z)",
      "Name (Z→A)": "Nom (Z→A)",
      "natural": "",
      "NEUTRAL": "Unisexe",
      "Price (High→Low)": "Prix (élevée→bas)",
      "Price (Low→High)": "Prix (bas→élevée)",
      "properties": "Caractéristiques",
      "rating": "Note",
      "Refine": "Affiner",
      "Search": "Recherche",
      "Search Result": "{{nbHits}} résultats de recherche affichés pour '<0>{{query}}</0>'",
      "showing results for": "Afficher les résultats pour",
      "Sort": "Trier",
      "Top Rated": "Les mieux notés",
      "We couldn't find any products that match your search.": "Nous n’avons trouvé aucun produit correspondant à votre recherche.",
      "Weight (Low→High)": "Poids (bas→élevée)",
      "What's New": "Nouveautés"
    }
  },
  "jp": {
    "container-search": {
      "categories": "カテゴリー",
      "collection": "コレクション",
      "colours": "色",
      "FEMALE": "ウィメンズ",
      "gender": "性別",
      "Here are a few alternate destinations that might help.": "以下の場所もご覧になりますか？",
      "In Stock": "在庫あり",
      "Items": "アイテム",
      "MALE": "メンズ",
      "materials": "素材",
      "Name (A→Z)": "名前順 (A → Z)",
      "Name (Z→A)": "名前順 (Z → A)",
      "natural": "",
      "NEUTRAL": "ユニセックス",
      "Price (High→Low)": "価格順 (高→低)",
      "Price (Low→High)": "価格順 (低→高)",
      "properties": "特性",
      "rating": "評価",
      "Refine": "絞り込む",
      "Search": "検索",
      "Search Result": "「<0>{{query}}</0>」の検索結果 {{nbHits}}件を表示しています",
      "showing results for": "検索結果を表示します。",
      "Sort": "並べ替え",
      "Top Rated": "最高評価",
      "We couldn't find any products that match your search.": "検索用語と一致する商品は見つかりませんでした。",
      "Weight (Low→High)": "重さ",
      "What's New": "新商品"
    }
  },
  "no": {
    "container-search": {
      "categories": "KATEGORIER",
      "collection": "Kolleksjon",
      "colours": "Farger",
      "FEMALE": "Dame",
      "gender": "Kjønn",
      "Here are a few alternate destinations that might help.": "Her er noen andre steder som kanskje kan hjelpe.",
      "In Stock": "på lager",
      "Items": "Varer",
      "MALE": "Herre",
      "materials": "Materialer",
      "Name (A→Z)": "Navn (A→Å)",
      "Name (Z→A)": "Navn (Å→A)",
      "natural": "",
      "NEUTRAL": "Unisex",
      "Price (High→Low)": "Pris (høy→lav)",
      "Price (Low→High)": "Pris (lav→høy)",
      "properties": "Egenskaper",
      "rating": "Vurdering",
      "Refine": "Begrens",
      "Search": "Søk",
      "Search Result": "See {{nbHits}} søkeresultater for '<0>{{query}}</0>'",
      "showing results for": "Viser resultater for",
      "Sort": "Sorter",
      "Top Rated": "Toppkarakter",
      "We couldn't find any products that match your search.": "Vi fant ingen produkter som oppfyller søkekriteriene dine.",
      "Weight (Low→High)": "Vekt (lav→høy)",
      "What's New": "Nyheter"
    }
  },
  "zh": {
    "container-search": {
      "categories": "分类",
      "collection": "系列",
      "colours": "颜色",
      "FEMALE": "女装",
      "gender": "性别",
      "Here are a few alternate destinations that might help.": "以下是一些可能有帮助的目的地。",
      "In Stock": "有货",
      "Items": "物品",
      "MALE": "男装",
      "materials": "材料",
      "Name (A→Z)": "名称（A到Z）",
      "Name (Z→A)": "名称（Z到A）",
      "natural": "",
      "NEUTRAL": "男女通用",
      "Price (High→Low)": "价格（从高到低）",
      "Price (Low→High)": "价格（从低到高）",
      "properties": "属性",
      "rating": "评级",
      "Refine": "细化",
      "Search": "搜索",
      "Search Result": "显示'<0>{{query}}</0>'的{{nbHits}}个搜索结果",
      "showing results for": "显示结果",
      "Sort": "分类",
      "Top Rated": "最佳产品",
      "We couldn't find any products that match your search.": "我们无法找到任何与搜索匹配的产品。",
      "Weight (Low→High)": "按重量（从低到高）",
      "What's New": "查看新品"
    }
  }
};

export { SearchContainer, createUserToken, resources_DONOTEDIT as i18nResources };
//# sourceMappingURL=index.js.map
